import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      login: 'Login',
      email: 'Email Address',
      password: 'Password',
      forgotPassword: 'Forgot Password?',
      rememberMe: 'Remember me',
      twoFA: 'Two-Factor Authentication',
      twoFACode: '6-digit code',
      liveAccount: 'Live Account',
      demoAccount: 'Demo Account',
      dashboard: 'Dashboard',
      trade: 'Trade',
      transactions: 'Transactions',
      accounts: 'Accounts',
      settings: 'Settings',
      balance: 'Balance',
      equity: 'Equity',
      margin: 'Margin Used',
      freeMargin: 'Free Margin',
      marginLevel: 'Margin Level',
      openPL: 'Open P&L',
      deposit: 'Deposit',
      withdraw: 'Withdraw',
      history: 'History',
      amount: 'Amount',
      paymentMethod: 'Payment Method',
      bankTransfer: 'Bank Transfer',
      creditCard: 'Credit / Debit Card',
      crypto: 'Cryptocurrency',
      submit: 'Submit',
      cancel: 'Cancel',
      confirm: 'Confirm',
      noData: 'No data found',
      loading: 'Loading...',
      logout: 'Logout',
      profile: 'Profile',
      kycStatus: 'KYC Status',
      verified: 'Verified',
      pending: 'Pending Review',
      rejected: 'Rejected',
      notSubmitted: 'Not Submitted',
      changePassword: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      language: 'Language',
      theme: 'Theme',
      dark: 'Dark',
      light: 'Light',
      notifications: 'Notifications',
      tickets: 'Support',
      createTicket: 'New Ticket',
      subject: 'Subject',
      message: 'Message',
      send: 'Send',
      name: 'Full Name',
      phone: 'Phone Number',
      country: 'Country',
      saveChanges: 'Save Changes',
      switchAccount: 'Switch Account',
      activeAccount: 'Active Account',
      invalidCredentials: 'Invalid credentials — use the demo accounts below to sign in',
      welcomeBack: 'Welcome back',
      marketNews: 'Market News',
      recentTransactions: 'Recent Transactions',
      status: 'Status',
      date: 'Date',
      type: 'Type',
      completed: 'Completed',
      processingStatus: 'Processing',
      pendingStatus: 'Pending',
      failedStatus: 'Failed',
      server: 'Server',
      leverage: 'Leverage',
      currency: 'Currency',
      accountType: 'Account Type',
      support: 'Support',
      analysis: 'Analysis',
      newTicket: 'New Ticket',
      newAccount: 'New Account',
      myAccounts: 'My Accounts',
      accountOverview: 'Account Overview',
      quickActions: 'Quick Actions',
      funds: 'Funds',
      security: 'Security',
      verification: 'Verification',
      twoFactorAuth: 'Two-Factor Auth',
      enable: 'Enable',
      disable: 'Disable',
      uploadDocument: 'Upload Document',
      changeAvatar: 'Change Photo',
      removeAvatar: 'Remove Photo',
      open: 'Open',
      inProgress: 'In Progress',
      resolved: 'Resolved',
      closed: 'Closed',
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      priority: 'Priority',
      category: 'Category',
      submitTicket: 'Submit Ticket',
      typeMessage: 'Type a message...',
      noTickets: 'No tickets yet',
      describeIssue: 'Describe your issue',
      marketInsights: 'Market insights & research',
      bullish: 'Bullish',
      bearish: 'Bearish',
      neutral: 'Neutral',
      readTime: 'read',
      allLoaded: 'All analyses loaded',
      loadingAnalyses: 'Loading analyses...',
      goodMorning: 'Good morning',
      goodAfternoon: 'Good afternoon',
      goodEvening: 'Good evening',
      bank: 'Bank',
      selectPaymentMethod: 'Select payment method',
      walletAddress: 'Wallet Address',
      networkWarning: 'Send only to this network',
      copyAddress: 'Copy Address',
      scanQR: 'Scan QR Code',
      demoCredentials: 'Demo Credentials',
      signIn: 'Sign In',
      verifyCode: 'Verify Code',
      enterCode: 'Enter the 6-digit code from your authenticator app',
      backToLogin: 'Back to Login',
      active: 'Active',
      switch: 'Switch',
      // Register
      createAccount: 'Create Account',
      fillDetails: 'Fill in the details below to get started.',
      fullNamePlaceholder: 'John Doe',
      emailPlaceholder: 'your@email.com',
      phonePlaceholder: '+1 (555) 000-0000',
      minCharsPlaceholder: 'Min. 8 characters',
      repeatPasswordPlaceholder: 'Repeat your password',
      passwordWeak: 'Weak',
      passwordMedium: 'Medium',
      passwordStrong: 'Strong',
      creatingAccount: 'Creating Account...',
      alreadyHaveAccount: 'Already have an account?',
      dontHaveAccount: "Don\'t have an account?",
      register: 'Register',
      back: 'Back',
      // Forgot Password
      forgotPasswordTitle: 'Forgot Password?',
      forgotPasswordDesc:
        "Enter your email address and we\'ll send you a link to reset your password.",
      checkInbox: 'Check your inbox',
      resetLinkSent: 'We sent a reset link to',
      sendResetLink: 'Send Reset Link',
      sending: 'Sending...',
      // Reset Password
      setNewPassword: 'Set New Password',
      setNewPasswordDesc: 'Enter the verification code from your email and choose a new password.',
      verificationCode: 'Verification Code',
      enterCodeFromEmail: 'Enter code from email',
      passwordUpdated: 'Password Updated!',
      canNowSignIn: 'You can now sign in with your new password.',
      goToLogin: 'Go to Login',
      updating: 'Updating...',
      updatePassword: 'Update Password',
      // Login screen
      signInToAccount: 'Sign in to your trading account',
      emailOrAccountId: 'Email or Account ID',
      enterYourPassword: 'Enter your password',
      signingIn: 'Signing in...',
      backToLoginLink: 'Back to login',
      twoFactorAuthTitle: 'Two-Factor Auth',
      enterSixDigitCode: 'Enter the 6-digit code from your authenticator app to continue.',
      authenticatorCode: 'Authenticator Code',
      codeRequired: 'Code is required',
      verifying: 'Verifying...',
      openAuthApp: 'Open your authenticator app and enter the current 6-digit code.',
      // Transactions
      tradingAccount: 'Trading Account',
      selectTradingAccount: 'Select Trading Account',
      availableBalance: 'Available Balance',
      selectDepositMethod: 'Select Deposit Method',
      selectWithdrawalMethod: 'Select Withdrawal Method',
      selectBankAccount: 'Select Bank Account',
      selectCryptocurrency: 'Select Cryptocurrency',
      bankDetails: 'Bank Details',
      bankName: 'Bank Name',
      accountHolderName: 'Account Holder Name',
      accountNumber: 'Account Number',
      swiftBic: 'SWIFT/BIC',
      amountLabel: 'Amount',
      submitDeposit: 'Submit Deposit',
      submitWithdrawal: 'Submit Withdrawal',
      noTransactions: 'No transactions yet',
      creditIn: 'Credit In',
      creditOut: 'Credit Out',
      typeDeposit: 'Deposit',
      typeWithdraw: 'Withdraw',
      sendToAddress: 'Send to address',
      withdrawalAddress: 'Withdrawal address',
      wrongAssetWarning: 'Sending wrong assets will result in permanent loss.',
      wireSwiftSepa: 'Wire / SWIFT / SEPA',
      btcEthUsdt: 'BTC, ETH, USDT & more',
      // Settings
      twoFAEnabled: 'Enabled — Google Authenticator',
      twoFADisabled: 'Disabled — Recommended to enable',
      activeSessions: 'Active Sessions',
      pushNotifications: 'Push Notifications',
      tradeAlertsDesc: 'Trade alerts, deposits, news',
      appVersion: 'App Version',
      termsOfService: 'Terms of Service',
      privacyPolicy: 'Privacy Policy',
      contactSupport: 'Contact Support',
      logOut: 'Log Out',
      headerSettings: 'Settings',
      headerLogout: 'Log Out',
      logOutConfirmTitle: 'Log Out',
      logOutConfirmMsg:
        'Are you sure you want to log out of application? Your open positions will not be affected.',
      stay: 'Stay',
      updatePasswordBtn: 'Update Password',
      saveChangesBtn: 'Save Changes',
      kycStatusLabel: 'KYC Status',
      dropFileHere: 'Drop file here or tap to upload',
      fileFormats: 'JPG, PNG, PDF — max 10MB',
      uploading: 'Uploading...',
      uploaded: 'Uploaded',
      docsReviewTime: 'Documents are reviewed within 1–3 business days.',
      step1InstallAuth: 'Step 1: Install Authenticator',
      downloadAuthApp: 'Download an authenticator app',
      step1Desc:
        'Install Google Authenticator or Authy on your mobile device. These apps generate time-based one-time passwords (TOTP) to secure your account.',
      iHaveApp: 'I have the app — Continue',
      step2ScanQR: 'Step 2: Scan QR Code',
      scanWithApp: 'Scan with your authenticator app',
      enterManually: 'Or enter the secret key manually:',
      enter6DigitVerify: 'Enter 6-digit code to verify',
      verifyEnable: 'Verify & Enable',
      twoFADisabledMsg: '2FA disabled — your account is less secure.',
      twoFAEnabledTitle: '2FA Enabled!',
      twoFAEnabledDesc:
        'Two-factor authentication is now active. Save your backup codes in a safe place.',
      doneSaveBackup: 'Done — Save Backup Codes',
      currentSession: 'Current',
      revoke: 'Revoke',
      preferences: 'Preferences',
      // Sub Accounts
      newAccountBtn: 'New Account',
      createNewAccount: 'Create New Account',
      accountTypeLabel: 'Account Type',
      summary: 'Summary',
      demoDesc: 'Practice with virtual funds',
      realDesc: 'Trade with real money',
      creating: 'Creating...',
      createAccountBtn: 'Create Account',
      noTradingAccounts: 'No trading accounts',
      createToGetStarted: 'Create a new account to get started',
      switchAccountTitle: 'Switch Account',
      switchAccountMsg: 'Switch to account #{{id}}? Your active session will be updated.',
      // Support
      ticketCount: '{{count}} ticket',
      ticketCountPlural: '{{count}} tickets',
      briefDescription: 'Brief description of your issue',
      selectCategory: 'Select category',
      describeInDetail: 'Describe your issue in detail...',
      ticketCreated: 'Ticket {{id}} created successfully',
      ticketClosed: 'This ticket is {{status}}. Open a new ticket if you need further assistance.',
      updatedAt: 'Updated {{time}}',
      // Analysis
      analysisTitle: 'Analysis',
      analysisDirection: 'Direction',
      analysisBuy: 'Buy',
      analysisSell: 'Sell',
      analysisBuySell: 'Buy / Sell',
      analysisDescription: 'Description',
      analysisTags: 'Tags',
      analysisEntry: 'Entry',
      analysisSL: 'Stop Loss',
      analysisTP1: 'TP 1',
      analysisTP2: 'TP 2',
      analysisTP3: 'TP 3',
      // Dashboard
      goodEvening2: 'Good evening 👋',
      // Notifications
      notificationsTitle: 'Notifications',
      markAllRead: 'Mark all read',
      noNotifications: 'No notifications',
      read: 'Read',
      unread: 'Unread',
      // Bottom Nav
      navDashboard: 'Dashboard',
      navTrade: 'Trade',
      navFunds: 'Funds',
      navAccounts: 'Accounts',
      navAnalysis: 'Analysis',
      navSettings: 'Settings',
      // Metric Cards
      atRisk: 'At Risk',
      // TopHeader
      darkModeEnabled: 'Dark mode enabled',
      lightModeEnabled: 'Light mode enabled',
      languageChanged: 'Language changed to {{lang}}',
      // PWA
      pwaInstallTitle: 'Install App',
      pwaInstallMsg: 'Add to home screen for quick access',
      pwaInstall: 'Install',
      pwaDismiss: "Don't show again",
      pwaHowToTitle: 'Install on your device',
      pwaHowToSubtitle: 'Follow the steps for your platform',
      pwaIos: 'iOS',
      pwaAndroid: 'Android',
      pwaIosStep1: 'Open this page in Safari',
      pwaIosStep2: 'Tap the Share button at the bottom of the screen',
      pwaIosStep3: 'Scroll down and tap Add to Home Screen',
      pwaIosStep4: 'Tap Add in the top-right corner',
      pwaAndroidStep1: 'Open this page in Chrome',
      pwaAndroidStep2: 'Tap the three-dot menu in the top-right',
      pwaAndroidStep3: 'Tap Install app or Add to Home screen',
      pwaAndroidStep4: 'Tap Install to confirm',
      pwaGotIt: 'Got it',
      allNewsLoaded: 'All news loaded',
      loadMore: 'Load more',
      amountUSD: 'Amount (USD)',
      avatarUpdated: 'Profile photo updated',
      disable2FATitle: 'Disable 2FA',
      disable2FAWarningTitle: 'Your account will be less secure',
      disable2FAWarningDesc:
        'Disabling two-factor authentication reduces the protection of your account. Anyone with your password may be able to sign in.',
      kycIdentityFront: 'Identity document — Front',
      kycIdentityBack: 'Identity document — Back',
      kycProofAddress: 'Proof of address',
      kycDocApprovedTitle: 'Approved',
      kycDocApprovedDesc: 'This document has been verified and approved.',
      minChars: 'At least 8 characters',
      mustIncludeUpperNum: 'Must include an uppercase letter and a number',
      passwordChanged: 'Password changed successfully',
      passwordChangeFailed: 'Failed to change password',
      passwordsNoMatch: 'Passwords do not match',
      profileUpdated: 'Profile updated',
      profileUpdateFailed: 'Failed to update profile',
      required: 'Required',
      searchCountry: 'Search country',
      setupStepsTitle: 'Setup steps',
      setup2FAStep1: 'Install Google Authenticator or Authy on your phone',
      setup2FAStep2: 'Scan the QR code or enter the secret key',
      setup2FAStep3: 'Enter the 6-digit code to enable 2FA',
      removeStepsTitle: 'How to disable',
      remove2FAStep1: 'Open your authenticator app',
      remove2FAStep2: 'Enter the current 6-digit code',
      remove2FAStep3: 'Confirm to disable two-factor authentication',
      twoFADisableFailed: 'Failed to disable 2FA',
      uploadedSuccess: '{{label}} uploaded successfully',
      termsContent:
        'By using this application you agree to these Terms of Service. You must be of legal age in your jurisdiction and are responsible for keeping your account credentials confidential. Trading involves a substantial risk of loss and is not suitable for every investor. We may suspend or terminate access in case of suspected fraud, market abuse, or any violation of these terms. For questions, contact support.',
      privacyContent:
        'We collect and process personal data needed to operate your account, complete verification, and provide trading services. This may include identity details, contact information, and transaction history. Data is stored securely and shared only when required by law or to deliver the service. You may request access, correction, or deletion of your data by contacting support.',
    },
  },
  tr: {
    translation: {
      login: 'Giriş Yap',
      email: 'E-posta Adresi',
      password: 'Şifre',
      forgotPassword: 'Şifremi Unuttum?',
      rememberMe: 'Beni Hatırla',
      twoFA: 'İki Faktörlü Doğrulama',
      twoFACode: '6 haneli kod',
      liveAccount: 'Gerçek Hesap',
      demoAccount: 'Demo Hesap',
      dashboard: 'Panel',
      trade: 'İşlem',
      transactions: 'İşlemler',
      accounts: 'Hesaplar',
      settings: 'Ayarlar',
      balance: 'Bakiye',
      equity: 'Özkaynak',
      margin: 'Kullanılan Marjin',
      freeMargin: 'Serbest Marjin',
      marginLevel: 'Marjin Seviyesi',
      openPL: 'Açık K/Z',
      deposit: 'Para Yatır',
      withdraw: 'Para Çek',
      history: 'Geçmiş',
      amount: 'Miktar',
      paymentMethod: 'Ödeme Yöntemi',
      bankTransfer: 'Banka Transferi',
      creditCard: 'Kredi / Banka Kartı',
      crypto: 'Kripto Para',
      submit: 'Gönder',
      cancel: 'İptal',
      confirm: 'Onayla',
      noData: 'Veri bulunamadı',
      loading: 'Yükleniyor...',
      logout: 'Çıkış Yap',
      profile: 'Profil',
      kycStatus: 'KYC Durumu',
      verified: 'Doğrulandı',
      pending: 'İnceleniyor',
      rejected: 'Reddedildi',
      notSubmitted: 'Gönderilmedi',
      changePassword: 'Şifre Değiştir',
      currentPassword: 'Mevcut Şifre',
      newPassword: 'Yeni Şifre',
      confirmPassword: 'Şifreyi Onayla',
      language: 'Dil',
      theme: 'Tema',
      dark: 'Koyu',
      light: 'Açık',
      notifications: 'Bildirimler',
      tickets: 'Destek',
      createTicket: 'Yeni Talep',
      subject: 'Konu',
      message: 'Mesaj',
      send: 'Gönder',
      name: 'Ad Soyad',
      phone: 'Telefon Numarası',
      country: 'Ülke',
      saveChanges: 'Değişiklikleri Kaydet',
      switchAccount: 'Hesap Değiştir',
      activeAccount: 'Aktif Hesap',
      invalidCredentials:
        'Geçersiz kimlik bilgileri — giriş için aşağıdaki demo hesapları kullanın',
      welcomeBack: 'Tekrar hoş geldiniz',
      marketNews: 'Piyasa Haberleri',
      recentTransactions: 'Son İşlemler',
      status: 'Durum',
      date: 'Tarih',
      type: 'Tür',
      completed: 'Tamamlandı',
      processingStatus: 'İşleniyor',
      pendingStatus: 'Beklemede',
      failedStatus: 'Başarısız',
      server: 'Sunucu',
      leverage: 'Kaldıraç',
      currency: 'Para Birimi',
      accountType: 'Hesap Türü',
      support: 'Destek',
      analysis: 'Analizler',
      newTicket: 'Yeni Talep',
      newAccount: 'Yeni Hesap',
      myAccounts: 'Hesaplarım',
      accountOverview: 'Hesap Özeti',
      quickActions: 'Hızlı İşlemler',
      funds: 'Para İşlemleri',
      security: 'Güvenlik',
      verification: 'Doğrulama',
      twoFactorAuth: 'İki Faktörlü Doğrulama',
      enable: 'Etkinleştir',
      disable: 'Devre Dışı Bırak',
      uploadDocument: 'Belge Yükle',
      changeAvatar: 'Fotoğraf Değiştir',
      removeAvatar: 'Fotoğrafı Kaldır',
      open: 'Açık',
      inProgress: 'İşlemde',
      resolved: 'Çözüldü',
      closed: 'Kapatıldı',
      low: 'Düşük',
      medium: 'Orta',
      high: 'Yüksek',
      priority: 'Öncelik',
      category: 'Kategori',
      submitTicket: 'Talep Oluştur',
      typeMessage: 'Mesaj yazın...',
      noTickets: 'Henüz talep yok',
      describeIssue: 'Sorununuzu açıklayın',
      marketInsights: 'Piyasa analizleri ve araştırmalar',
      bullish: 'Yükseliş',
      bearish: 'Düşüş',
      neutral: 'Nötr',
      readTime: 'okuma',
      allLoaded: 'Tüm analizler yüklendi',
      loadingAnalyses: 'Analizler yükleniyor...',
      goodMorning: 'Günaydın',
      goodAfternoon: 'İyi öğleden sonralar',
      goodEvening: 'İyi akşamlar',
      bank: 'Banka',
      selectPaymentMethod: 'Ödeme yöntemi seçin',
      walletAddress: 'Cüzdan Adresi',
      networkWarning: 'Yalnızca bu ağa gönderin',
      copyAddress: 'Adresi Kopyala',
      scanQR: 'QR Kodu Tara',
      demoCredentials: 'Demo Hesap Bilgileri',
      signIn: 'Giriş Yap',
      verifyCode: 'Kodu Doğrula',
      enterCode: 'Kimlik doğrulama uygulamanızdaki 6 haneli kodu girin',
      backToLogin: 'Girişe Dön',
      active: 'Aktif',
      switch: 'Geç',
      // Register
      createAccount: 'Hesap Oluştur',
      fillDetails: 'Başlamak için aşağıdaki bilgileri doldurun.',
      fullNamePlaceholder: 'Ad Soyad',
      emailPlaceholder: 'eposta@adresiniz.com',
      phonePlaceholder: '+90 (555) 000-0000',
      minCharsPlaceholder: 'Min. 8 karakter',
      repeatPasswordPlaceholder: 'Şifrenizi tekrar girin',
      passwordWeak: 'Zayıf',
      passwordMedium: 'Orta',
      passwordStrong: 'Güçlü',
      creatingAccount: 'Hesap Oluşturuluyor...',
      alreadyHaveAccount: 'Zaten hesabınız var mı?',
      dontHaveAccount: 'Hesabınız yok mu?',
      register: 'Kayıt Ol',
      back: 'Geri',
      // Forgot Password
      forgotPasswordTitle: 'Şifremi Unuttum?',
      forgotPasswordDesc: 'E-posta adresinizi girin, şifre sıfırlama bağlantısı göndereceğiz.',
      checkInbox: 'Gelen kutunuzu kontrol edin',
      resetLinkSent: 'Sıfırlama bağlantısı gönderildi:',
      sendResetLink: 'Sıfırlama Bağlantısı Gönder',
      sending: 'Gönderiliyor...',
      // Reset Password
      setNewPassword: 'Yeni Şifre Belirle',
      setNewPasswordDesc: 'E-postanızdaki doğrulama kodunu girin ve yeni şifrenizi seçin.',
      verificationCode: 'Doğrulama Kodu',
      enterCodeFromEmail: 'E-postadaki kodu girin',
      passwordUpdated: 'Şifre Güncellendi!',
      canNowSignIn: 'Artık yeni şifrenizle giriş yapabilirsiniz.',
      goToLogin: 'Girişe Git',
      updating: 'Güncelleniyor...',
      updatePassword: 'Şifreyi Güncelle',
      // Login screen
      signInToAccount: 'Ticaret hesabınıza giriş yapın',
      emailOrAccountId: 'E-posta veya Hesap ID',
      enterYourPassword: 'Şifrenizi girin',
      signingIn: 'Giriş yapılıyor...',
      backToLoginLink: 'Girişe dön',
      twoFactorAuthTitle: 'İki Faktörlü Doğrulama',
      enterSixDigitCode: 'Devam etmek için kimlik doğrulama uygulamanızdaki 6 haneli kodu girin.',
      authenticatorCode: 'Doğrulayıcı Kodu',
      codeRequired: 'Kod gereklidir',
      verifying: 'Doğrulanıyor...',
      openAuthApp: 'Kimlik doğrulama uygulamanızı açın ve mevcut 6 haneli kodu girin.',
      // Transactions
      tradingAccount: 'İşlem Hesabı',
      selectTradingAccount: 'İşlem Hesabı Seçin',
      availableBalance: 'Kullanılabilir Bakiye',
      selectDepositMethod: 'Para Yatırma Yöntemi Seçin',
      selectWithdrawalMethod: 'Yöntem Seçin',
      selectBankAccount: 'Banka Hesabı Seçin',
      selectCryptocurrency: 'Kripto Para Seçin',
      bankDetails: 'Banka Detayları',
      bankName: 'Banka Adı',
      accountHolderName: 'Hesap Sahibi Adı',
      accountNumber: 'Hesap Numarası',
      swiftBic: 'SWIFT/BIC',
      amountLabel: 'Miktar',
      submitDeposit: 'Para Yatırma İsteği Gönder',
      submitWithdrawal: 'Talep Gönder',
      noTransactions: 'Henüz işlem yok',
      creditIn: 'Kredi Girişi',
      creditOut: 'Kredi Çıkışı',
      typeDeposit: 'Deposit',
      typeWithdraw: 'Withdraw',
      sendToAddress: 'Bu adrese gönderin',
      withdrawalAddress: 'Adres',
      wrongAssetWarning: 'Yanlış varlık göndermek kalıcı kayba yol açar.',
      wireSwiftSepa: 'Havale / SWIFT / SEPA',
      btcEthUsdt: 'BTC, ETH, USDT ve daha fazlası',
      // Settings
      twoFAEnabled: 'Etkin — Google Authenticator',
      twoFADisabled: 'Devre Dışı — Etkinleştirmeniz önerilir',
      activeSessions: 'Aktif Oturumlar',
      pushNotifications: 'Anlık Bildirimler',
      tradeAlertsDesc: 'İşlem uyarıları, para yatırma, haberler',
      appVersion: 'Uygulama Sürümü',
      termsOfService: 'Kullanım Koşulları',
      privacyPolicy: 'Gizlilik Politikası',
      contactSupport: 'Destek ile İletişim',
      logOut: 'Çıkış Yap',
      headerSettings: 'Ayarlar',
      headerLogout: 'Çıkış Yap',
      logOutConfirmTitle: 'Çıkış Yap',
      logOutConfirmMsg:
        'Uygulamadan çıkmak istediğinizden emin misiniz? Açık pozisyonlarınız etkilenmeyecektir.',
      stay: 'Kal',
      updatePasswordBtn: 'Şifreyi Güncelle',
      saveChangesBtn: 'Değişiklikleri Kaydet',
      kycStatusLabel: 'KYC Durumu',
      dropFileHere: 'Dosyayı buraya bırakın veya yüklemek için dokunun',
      fileFormats: 'JPG, PNG, PDF — maks 10MB',
      uploading: 'Yükleniyor...',
      uploaded: 'Yüklendi',
      docsReviewTime: 'Belgeler 1–3 iş günü içinde incelenir.',
      step1InstallAuth: '1. Adım: Doğrulayıcı Uygulaması Yükleyin',
      downloadAuthApp: 'Bir doğrulayıcı uygulama indirin',
      step1Desc:
        'Mobil cihazınıza Google Authenticator veya Authy yükleyin. Bu uygulamalar hesabınızı güvence altına almak için zamana dayalı tek kullanımlık şifreler (TOTP) üretir.',
      iHaveApp: 'Uygulama var — Devam Et',
      step2ScanQR: '2. Adım: QR Kodu Tarayın',
      scanWithApp: 'Doğrulayıcı uygulamanızla tarayın',
      enterManually: 'Veya gizli anahtarı manuel olarak girin:',
      enter6DigitVerify: 'Doğrulamak için 6 haneli kodu girin',
      verifyEnable: 'Doğrula ve Etkinleştir',
      twoFADisabledMsg: '2FA devre dışı bırakıldı — hesabınız daha az güvenli.',
      twoFAEnabledTitle: '2FA Etkinleştirildi!',
      twoFAEnabledDesc:
        'İki faktörlü kimlik doğrulama artık aktif. Yedek kodlarınızı güvenli bir yerde saklayın.',
      doneSaveBackup: 'Tamam — Yedek Kodları Kaydet',
      currentSession: 'Mevcut',
      revoke: 'İptal Et',
      preferences: 'Tercihler',
      // Sub Accounts
      newAccountBtn: 'Yeni Hesap',
      createNewAccount: 'Yeni Hesap Oluştur',
      accountTypeLabel: 'Hesap Türü',
      summary: 'Özet',
      demoDesc: 'Sanal fonlarla pratik yapın',
      realDesc: 'Gerçek parayla işlem yapın',
      creating: 'Oluşturuluyor...',
      createAccountBtn: 'Hesap Oluştur',
      noTradingAccounts: 'İşlem hesabı yok',
      createToGetStarted: 'Başlamak için yeni bir hesap oluşturun',
      switchAccountTitle: 'Hesap Değiştir',
      switchAccountMsg: '#{{id}} hesabına geçilsin mi? Aktif oturumunuz güncellenecektir.',
      // Support
      ticketCount: '{{count}} talep',
      ticketCountPlural: '{{count}} talep',
      briefDescription: 'Sorununuzun kısa açıklaması',
      selectCategory: 'Kategori seçin',
      describeInDetail: 'Sorununuzu ayrıntılı olarak açıklayın...',
      ticketCreated: '{{id}} talebi başarıyla oluşturuldu',
      ticketClosed: 'Bu talep {{status}} durumunda. Daha fazla yardım için yeni bir talep açın.',
      updatedAt: '{{time}} güncellendi',
      // Analysis
      analysisTitle: 'Analizler',
      analysisDirection: 'Yön',
      analysisBuy: 'Alış',
      analysisSell: 'Satış',
      analysisBuySell: 'Alış / Satış',
      analysisDescription: 'Açıklama',
      analysisTags: 'Etiketler',
      analysisEntry: 'Giriş',
      analysisSL: 'Zarar Durdur',
      analysisTP1: 'TP 1',
      analysisTP2: 'TP 2',
      analysisTP3: 'TP 3',
      // Dashboard
      goodEvening2: 'İyi akşamlar 👋',
      // Notifications
      notificationsTitle: 'Bildirimler',
      markAllRead: 'Tümünü okundu işaretle',
      noNotifications: 'Bildirim yok',
      read: 'Okundu',
      unread: 'Okunmadı',
      // Bottom Nav
      navDashboard: 'Panel',
      navTrade: 'İşlem',
      navFunds: 'Para',
      navAccounts: 'Hesaplar',
      navAnalysis: 'Analizler',
      navSettings: 'Ayarlar',
      // Metric Cards
      atRisk: 'Riskli',
      // TopHeader
      darkModeEnabled: 'Koyu mod etkinleştirildi',
      lightModeEnabled: 'Açık mod etkinleştirildi',
      languageChanged: 'Dil {{lang}} olarak değiştirildi',
      // PWA
      pwaInstallTitle: 'Uygulamayı Yükle',
      pwaInstallMsg: 'Hızlı erişim için ana ekrana ekleyin',
      pwaInstall: 'Yükle',
      pwaDismiss: 'Bir daha gösterme',
      pwaHowToTitle: 'Cihazınıza yükleyin',
      pwaHowToSubtitle: 'Platformunuza uygun adımları izleyin',
      pwaIos: 'iOS',
      pwaAndroid: 'Android',
      pwaIosStep1: 'Bu sayfayı Safari’de açın',
      pwaIosStep2: 'Ekranın altındaki Paylaş düğmesine dokunun',
      pwaIosStep3: 'Aşağı kaydırın ve Ana Ekrana Ekle’ye dokunun',
      pwaIosStep4: 'Sağ üst köşedeki Ekle’ye dokunun',
      pwaAndroidStep1: 'Bu sayfayı Chrome’da açın',
      pwaAndroidStep2: 'Sağ üstteki üç nokta menüsüne dokunun',
      pwaAndroidStep3: 'Uygulamayı yükle veya Ana ekrana ekle’ye dokunun',
      pwaAndroidStep4: 'Onaylamak için Yükle’ye dokunun',
      pwaGotIt: 'Anladım',
      allNewsLoaded: 'Tüm haberler yüklendi',
      loadMore: 'Daha fazla yükle',
      amountUSD: 'Tutar (USD)',
      avatarUpdated: 'Profil fotoğrafı güncellendi',
      disable2FATitle: '2FA’yı Kapat',
      disable2FAWarningTitle: 'Hesabınız daha az güvenli olacak',
      disable2FAWarningDesc:
        'İki faktörlü doğrulamayı kapatmak hesabınızın korumasını azaltır. Şifrenize sahip herkes giriş yapabilir.',
      kycIdentityFront: 'Kimlik belgesi — Ön yüz',
      kycIdentityBack: 'Kimlik belgesi — Arka yüz',
      kycProofAddress: 'Adres belgesi',
      kycDocApprovedTitle: 'Onaylandı',
      kycDocApprovedDesc: 'Bu belge doğrulanmış ve onaylanmıştır.',
      minChars: 'En az 8 karakter',
      mustIncludeUpperNum: 'Bir büyük harf ve bir rakam içermelidir',
      passwordChanged: 'Şifre başarıyla değiştirildi',
      passwordChangeFailed: 'Şifre değiştirilemedi',
      passwordsNoMatch: 'Şifreler eşleşmiyor',
      profileUpdated: 'Profil güncellendi',
      profileUpdateFailed: 'Profil güncellenemedi',
      required: 'Zorunlu',
      searchCountry: 'Ülke ara',
      setupStepsTitle: 'Kurulum adımları',
      setup2FAStep1: 'Telefonunuza Google Authenticator veya Authy yükleyin',
      setup2FAStep2: 'QR kodunu tarayın veya gizli anahtarı girin',
      setup2FAStep3: '2FA’yı etkinleştirmek için 6 haneli kodu girin',
      removeStepsTitle: 'Nasıl kapatılır',
      remove2FAStep1: 'Doğrulayıcı uygulamanızı açın',
      remove2FAStep2: 'Güncel 6 haneli kodu girin',
      remove2FAStep3: 'İki faktörlü doğrulamayı kapatmayı onaylayın',
      twoFADisableFailed: '2FA kapatılamadı',
      uploadedSuccess: '{{label}} başarıyla yüklendi',
      termsContent:
        'Bu uygulamayı kullanarak Kullanım Koşullarını kabul etmiş olursunuz. Yargı bölgenizde yasal yaşta olmalı ve hesap bilgilerinizin gizliliğinden sorumlu olmalısınız. Alım satım önemli zarar riski içerir ve her yatırımcı için uygun olmayabilir. Dolandırıcılık, piyasa suistimali veya bu koşulların ihlali şüphesinde erişim askıya alınabilir veya sonlandırılabilir. Sorularınız için destek ile iletişime geçin.',
      privacyContent:
        'Hesabınızı işletmek, doğrulamayı tamamlamak ve işlem hizmetlerini sunmak için gerekli kişisel verileri toplar ve işleriz. Buna kimlik bilgileri, iletişim bilgileri ve işlem geçmişi dahil olabilir. Veriler güvenli şekilde saklanır ve yalnızca yasal zorunluluk veya hizmetin sunulması için paylaşılır. Destek ile iletişime geçerek verilerinize erişim, düzeltme veya silme talep edebilirsiniz.',
    },
  },
  es: {
    translation: {
      login: 'Iniciar Sesión',
      email: 'Correo Electrónico',
      password: 'Contraseña',
      forgotPassword: '¿Olvidaste tu contraseña?',
      rememberMe: 'Recuérdame',
      twoFA: 'Autenticación de Dos Factores',
      twoFACode: 'Código de 6 dígitos',
      liveAccount: 'Cuenta Real',
      demoAccount: 'Cuenta Demo',
      balance: 'Saldo',
      equity: 'Patrimonio',
      deposit: 'Depositar',
      withdraw: 'Retirar',
      noData: 'No se encontraron datos',
      loading: 'Cargando...',
      dashboard: 'Panel',
      trade: 'Operar',
      transactions: 'Transacciones',
      accounts: 'Cuentas',
      settings: 'Configuración',
      margin: 'Margen Usado',
      freeMargin: 'Margen Libre',
      marginLevel: 'Nivel de Margen',
      openPL: 'P&G Abierto',
      history: 'Historial',
      amount: 'Monto',
      paymentMethod: 'Método de Pago',
      bankTransfer: 'Transferencia Bancaria',
      creditCard: 'Tarjeta de Crédito / Débito',
      crypto: 'Criptomoneda',
      submit: 'Enviar',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      logout: 'Cerrar Sesión',
      profile: 'Perfil',
      kycStatus: 'Estado KYC',
      verified: 'Verificado',
      pending: 'En Revisión',
      rejected: 'Rechazado',
      notSubmitted: 'No Enviado',
      changePassword: 'Cambiar Contraseña',
      currentPassword: 'Contraseña Actual',
      newPassword: 'Nueva Contraseña',
      confirmPassword: 'Confirmar Contraseña',
      language: 'Idioma',
      theme: 'Tema',
      dark: 'Oscuro',
      light: 'Claro',
      notifications: 'Notificaciones',
      tickets: 'Soporte',
      createTicket: 'Nuevo Ticket',
      subject: 'Asunto',
      message: 'Mensaje',
      send: 'Enviar',
      name: 'Nombre Completo',
      phone: 'Número de Teléfono',
      country: 'País',
      saveChanges: 'Guardar Cambios',
      switchAccount: 'Cambiar Cuenta',
      activeAccount: 'Cuenta Activa',
      invalidCredentials: 'Credenciales inválidas — usa las cuentas demo para iniciar sesión',
      welcomeBack: 'Bienvenido de nuevo',
      marketNews: 'Noticias del Mercado',
      recentTransactions: 'Transacciones Recientes',
      status: 'Estado',
      date: 'Fecha',
      type: 'Tipo',
      completed: 'Completado',
      processingStatus: 'Procesando',
      pendingStatus: 'Pendiente',
      failedStatus: 'Fallido',
      server: 'Servidor',
      leverage: 'Apalancamiento',
      currency: 'Moneda',
      accountType: 'Tipo de Cuenta',
      support: 'Soporte',
      analysis: 'Análisis',
      newTicket: 'Nuevo Ticket',
      newAccount: 'Nueva Cuenta',
      myAccounts: 'Mis Cuentas',
      accountOverview: 'Resumen de Cuenta',
      quickActions: 'Acciones Rápidas',
      funds: 'Fondos',
      security: 'Seguridad',
      verification: 'Verificación',
      twoFactorAuth: 'Autenticación de Dos Factores',
      enable: 'Activar',
      disable: 'Desactivar',
      uploadDocument: 'Subir Documento',
      changeAvatar: 'Cambiar Foto',
      removeAvatar: 'Eliminar Foto',
      open: 'Abierto',
      inProgress: 'En Progreso',
      resolved: 'Resuelto',
      closed: 'Cerrado',
      low: 'Bajo',
      medium: 'Medio',
      high: 'Alto',
      priority: 'Prioridad',
      category: 'Categoría',
      submitTicket: 'Enviar Ticket',
      typeMessage: 'Escribe un mensaje...',
      noTickets: 'Sin tickets aún',
      describeIssue: 'Describe tu problema',
      marketInsights: 'Análisis e investigación del mercado',
      bullish: 'Alcista',
      bearish: 'Bajista',
      neutral: 'Neutral',
      readTime: 'lectura',
      allLoaded: 'Todos los análisis cargados',
      loadingAnalyses: 'Cargando análisis...',
      goodMorning: 'Buenos días',
      goodAfternoon: 'Buenas tardes',
      goodEvening: 'Buenas noches',
      bank: 'Banco',
      selectPaymentMethod: 'Seleccionar método de pago',
      walletAddress: 'Dirección de Billetera',
      networkWarning: 'Enviar solo a esta red',
      copyAddress: 'Copiar Dirección',
      scanQR: 'Escanear Código QR',
      demoCredentials: 'Credenciales Demo',
      signIn: 'Iniciar Sesión',
      verifyCode: 'Verificar Código',
      enterCode: 'Ingresa el código de 6 dígitos de tu app de autenticación',
      backToLogin: 'Volver al Login',
      active: 'Activo',
      switch: 'Cambiar',
      // Register
      createAccount: 'Crear Cuenta',
      fillDetails: 'Completa los detalles a continuación para comenzar.',
      fullNamePlaceholder: 'Juan García',
      emailPlaceholder: 'tu@correo.com',
      phonePlaceholder: '+1 (555) 000-0000',
      minCharsPlaceholder: 'Mín. 8 caracteres',
      repeatPasswordPlaceholder: 'Repite tu contraseña',
      passwordWeak: 'Débil',
      passwordMedium: 'Media',
      passwordStrong: 'Fuerte',
      creatingAccount: 'Creando Cuenta...',
      alreadyHaveAccount: '¿Ya tienes una cuenta?',
      dontHaveAccount: '¿No tienes una cuenta?',
      register: 'Registrarse',
      back: 'Volver',
      // Forgot Password
      forgotPasswordTitle: '¿Olvidaste tu contraseña?',
      forgotPasswordDesc:
        'Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.',
      checkInbox: 'Revisa tu bandeja de entrada',
      resetLinkSent: 'Enviamos un enlace de restablecimiento a',
      sendResetLink: 'Enviar Enlace de Restablecimiento',
      sending: 'Enviando...',
      // Reset Password
      setNewPassword: 'Establecer Nueva Contraseña',
      setNewPasswordDesc:
        'Ingresa el código de verificación de tu correo y elige una nueva contraseña.',
      verificationCode: 'Código de Verificación',
      enterCodeFromEmail: 'Ingresa el código del correo',
      passwordUpdated: '¡Contraseña Actualizada!',
      canNowSignIn: 'Ahora puedes iniciar sesión con tu nueva contraseña.',
      goToLogin: 'Ir al Login',
      updating: 'Actualizando...',
      updatePassword: 'Actualizar Contraseña',
      // Login screen
      signInToAccount: 'Inicia sesión en tu cuenta de trading',
      emailOrAccountId: 'Correo o ID de Cuenta',
      enterYourPassword: 'Ingresa tu contraseña',
      signingIn: 'Iniciando sesión...',
      backToLoginLink: 'Volver al login',
      twoFactorAuthTitle: 'Autenticación de Dos Factores',
      enterSixDigitCode:
        'Ingresa el código de 6 dígitos de tu app de autenticación para continuar.',
      authenticatorCode: 'Código de Autenticación',
      codeRequired: 'El código es requerido',
      verifying: 'Verificando...',
      openAuthApp: 'Abre tu app de autenticación e ingresa el código actual de 6 dígitos.',
      // Transactions
      tradingAccount: 'Cuenta de Trading',
      selectTradingAccount: 'Seleccionar Cuenta de Trading',
      availableBalance: 'Saldo Disponible',
      selectDepositMethod: 'Seleccionar Método de Depósito',
      selectWithdrawalMethod: 'Seleccionar Método de Retiro',
      selectBankAccount: 'Seleccionar Cuenta Bancaria',
      selectCryptocurrency: 'Seleccionar Criptomoneda',
      bankDetails: 'Detalles Bancarios',
      bankName: 'Nombre del Banco',
      accountHolderName: 'Nombre del Titular',
      accountNumber: 'Número de Cuenta',
      swiftBic: 'SWIFT/BIC',
      amountLabel: 'Monto',
      submitDeposit: 'Enviar Depósito',
      submitWithdrawal: 'Enviar Retiro',
      noTransactions: 'Sin transacciones aún',
      creditIn: 'Entrada de crédito',
      creditOut: 'Salida de crédito',
      typeDeposit: 'Depósito',
      typeWithdraw: 'Retiro',
      sendToAddress: 'Enviar a dirección',
      withdrawalAddress: 'Dirección de retiro',
      wrongAssetWarning: 'Enviar activos incorrectos resultará en pérdida permanente.',
      wireSwiftSepa: 'Wire / SWIFT / SEPA',
      btcEthUsdt: 'BTC, ETH, USDT y más',
      // Settings
      twoFAEnabled: 'Activado — Google Authenticator',
      twoFADisabled: 'Desactivado — Se recomienda activar',
      activeSessions: 'Sesiones Activas',
      pushNotifications: 'Notificaciones Push',
      tradeAlertsDesc: 'Alertas de trading, depósitos, noticias',
      appVersion: 'Versión de la App',
      termsOfService: 'Términos de Servicio',
      privacyPolicy: 'Política de Privacidad',
      contactSupport: 'Contactar Soporte',
      logOut: 'Cerrar Sesión',
      headerSettings: 'Configuración',
      headerLogout: 'Cerrar Sesión',
      logOutConfirmTitle: 'Cerrar Sesión',
      logOutConfirmMsg:
        '¿Estás seguro de que quieres cerrar sesión en application? Tus posiciones abiertas no se verán afectadas.',
      stay: 'Quedarme',
      updatePasswordBtn: 'Actualizar Contraseña',
      saveChangesBtn: 'Guardar Cambios',
      kycStatusLabel: 'Estado KYC',
      dropFileHere: 'Suelta el archivo aquí o toca para subir',
      fileFormats: 'JPG, PNG, PDF — máx 10MB',
      uploading: 'Subiendo...',
      uploaded: 'Subido',
      docsReviewTime: 'Los documentos se revisan en 1–3 días hábiles.',
      step1InstallAuth: 'Paso 1: Instalar Autenticador',
      downloadAuthApp: 'Descarga una app de autenticación',
      step1Desc:
        'Instala Google Authenticator o Authy en tu dispositivo móvil. Estas apps generan contraseñas de un solo uso basadas en tiempo (TOTP) para proteger tu cuenta.',
      iHaveApp: 'Tengo la app — Continuar',
      step2ScanQR: 'Paso 2: Escanear Código QR',
      scanWithApp: 'Escanea con tu app de autenticación',
      enterManually: 'O ingresa la clave secreta manualmente:',
      enter6DigitVerify: 'Ingresa el código de 6 dígitos para verificar',
      verifyEnable: 'Verificar y Activar',
      twoFADisabledMsg: '2FA desactivado — tu cuenta es menos segura.',
      twoFAEnabledTitle: '¡2FA Activado!',
      twoFAEnabledDesc:
        'La autenticación de dos factores está ahora activa. Guarda tus códigos de respaldo en un lugar seguro.',
      doneSaveBackup: 'Listo — Guardar Códigos de Respaldo',
      currentSession: 'Actual',
      revoke: 'Revocar',
      preferences: 'Preferencias',
      // Sub Accounts
      newAccountBtn: 'Nueva Cuenta',
      createNewAccount: 'Crear Nueva Cuenta',
      accountTypeLabel: 'Tipo de Cuenta',
      summary: 'Resumen',
      demoDesc: 'Practica con fondos virtuales',
      realDesc: 'Opera con dinero real',
      creating: 'Creando...',
      createAccountBtn: 'Crear Cuenta',
      noTradingAccounts: 'Sin cuentas de trading',
      createToGetStarted: 'Crea una nueva cuenta para comenzar',
      switchAccountTitle: 'Cambiar Cuenta',
      switchAccountMsg: '¿Cambiar a la cuenta #{{id}}? Tu sesión activa se actualizará.',
      // Support
      ticketCount: '{{count}} ticket',
      ticketCountPlural: '{{count}} tickets',
      briefDescription: 'Breve descripción de tu problema',
      selectCategory: 'Seleccionar categoría',
      describeInDetail: 'Describe tu problema en detalle...',
      ticketCreated: 'Ticket {{id}} creado exitosamente',
      ticketClosed: 'Este ticket está {{status}}. Abre un nuevo ticket si necesitas más ayuda.',
      updatedAt: 'Actualizado {{time}}',
      // Analysis
      analysisTitle: 'Análisis',
      analysisDirection: 'Dirección',
      analysisBuy: 'Compra',
      analysisSell: 'Venta',
      analysisBuySell: 'Compra / Venta',
      analysisDescription: 'Descripción',
      analysisTags: 'Etiquetas',
      analysisEntry: 'Entrada',
      analysisSL: 'Stop Loss',
      analysisTP1: 'TP 1',
      analysisTP2: 'TP 2',
      analysisTP3: 'TP 3',
      // Dashboard
      goodEvening2: 'Buenas noches 👋',
      // Notifications
      notificationsTitle: 'Notificaciones',
      markAllRead: 'Marcar todo como leído',
      noNotifications: 'Sin notificaciones',
      read: 'Leído',
      unread: 'No leído',
      // Bottom Nav
      navDashboard: 'Panel',
      navTrade: 'Operar',
      navFunds: 'Fondos',
      navAccounts: 'Cuentas',
      navAnalysis: 'Análisis',
      navSettings: 'Ajustes',
      // Metric Cards
      atRisk: 'En Riesgo',
      // TopHeader
      darkModeEnabled: 'Modo oscuro activado',
      lightModeEnabled: 'Modo claro activado',
      languageChanged: 'Idioma cambiado a {{lang}}',
      // PWA
      pwaInstallTitle: 'Instalar App',
      pwaInstallMsg: 'Agrégala a tu pantalla de inicio para acceso rápido',
      pwaInstall: 'Instalar',
      pwaDismiss: 'No volver a mostrar',
      pwaHowToTitle: 'Instalar en tu dispositivo',
      pwaHowToSubtitle: 'Sigue los pasos de tu plataforma',
      pwaIos: 'iOS',
      pwaAndroid: 'Android',
      pwaIosStep1: 'Abre esta página en Safari',
      pwaIosStep2: 'Toca el botón Compartir en la parte inferior',
      pwaIosStep3: 'Desplázate y toca Añadir a pantalla de inicio',
      pwaIosStep4: 'Toca Añadir en la esquina superior derecha',
      pwaAndroidStep1: 'Abre esta página en Chrome',
      pwaAndroidStep2: 'Toca el menú de tres puntos en la esquina superior derecha',
      pwaAndroidStep3: 'Toca Instalar app o Añadir a pantalla de inicio',
      pwaAndroidStep4: 'Toca Instalar para confirmar',
      pwaGotIt: 'Entendido',
      allNewsLoaded: 'Todas las noticias cargadas',
      loadMore: 'Cargar más',
      amountUSD: 'Monto (USD)',
      avatarUpdated: 'Foto de perfil actualizada',
      disable2FATitle: 'Desactivar 2FA',
      disable2FAWarningTitle: 'Tu cuenta será menos segura',
      disable2FAWarningDesc:
        'Desactivar la autenticación de dos factores reduce la protección de tu cuenta. Cualquiera con tu contraseña podría iniciar sesión.',
      kycIdentityFront: 'Documento de identidad — Frente',
      kycIdentityBack: 'Documento de identidad — Reverso',
      kycProofAddress: 'Comprobante de domicilio',
      kycDocApprovedTitle: 'Aprobado',
      kycDocApprovedDesc: 'Este documento ha sido verificado y aprobado.',
      minChars: 'Al menos 8 caracteres',
      mustIncludeUpperNum: 'Debe incluir una letra mayúscula y un número',
      passwordChanged: 'Contraseña cambiada correctamente',
      passwordChangeFailed: 'No se pudo cambiar la contraseña',
      passwordsNoMatch: 'Las contraseñas no coinciden',
      profileUpdated: 'Perfil actualizado',
      profileUpdateFailed: 'No se pudo actualizar el perfil',
      required: 'Obligatorio',
      searchCountry: 'Buscar país',
      setupStepsTitle: 'Pasos de configuración',
      setup2FAStep1: 'Instala Google Authenticator o Authy en tu teléfono',
      setup2FAStep2: 'Escanea el código QR o introduce la clave secreta',
      setup2FAStep3: 'Introduce el código de 6 dígitos para activar 2FA',
      removeStepsTitle: 'Cómo desactivar',
      remove2FAStep1: 'Abre tu aplicación de autenticación',
      remove2FAStep2: 'Introduce el código actual de 6 dígitos',
      remove2FAStep3: 'Confirma para desactivar la autenticación de dos factores',
      twoFADisableFailed: 'No se pudo desactivar 2FA',
      uploadedSuccess: '{{label}} se subió correctamente',
      termsContent:
        'Al usar esta aplicación aceptas estos Términos de Servicio. Debes tener la edad legal en tu jurisdicción y eres responsable de mantener la confidencialidad de tus credenciales. El trading implica un riesgo sustancial de pérdida y no es adecuado para todos los inversores. Podemos suspender o cancelar el acceso en caso de sospecha de fraude, abuso de mercado o incumplimiento de estos términos. Para consultas, contacta con soporte.',
      privacyContent:
        'Recopilamos y procesamos los datos personales necesarios para operar tu cuenta, completar la verificación y prestar servicios de trading. Esto puede incluir datos de identidad, información de contacto e historial de transacciones. Los datos se almacenan de forma segura y solo se comparten cuando lo exige la ley o para prestar el servicio. Puedes solicitar acceso, corrección o eliminación de tus datos contactando con soporte.',
    },
  },
  de: {
    translation: {
      login: 'Anmelden',
      email: 'E-Mail-Adresse',
      password: 'Passwort',
      forgotPassword: 'Passwort vergessen?',
      rememberMe: 'Angemeldet bleiben',
      twoFA: 'Zwei-Faktor-Authentifizierung',
      twoFACode: '6-stelliger Code',
      liveAccount: 'Live-Konto',
      demoAccount: 'Demo-Konto',
      balance: 'Kontostand',
      equity: 'Eigenkapital',
      deposit: 'Einzahlen',
      withdraw: 'Abheben',
      noData: 'Keine Daten gefunden',
      loading: 'Laden...',
      dashboard: 'Dashboard',
      trade: 'Handel',
      transactions: 'Transaktionen',
      accounts: 'Konten',
      settings: 'Einstellungen',
      margin: 'Verwendete Marge',
      freeMargin: 'Freie Marge',
      marginLevel: 'Margenebene',
      openPL: 'Offener G&V',
      history: 'Verlauf',
      amount: 'Betrag',
      paymentMethod: 'Zahlungsmethode',
      bankTransfer: 'Banküberweisung',
      creditCard: 'Kredit- / Debitkarte',
      crypto: 'Kryptowährung',
      submit: 'Absenden',
      cancel: 'Abbrechen',
      confirm: 'Bestätigen',
      logout: 'Abmelden',
      profile: 'Profil',
      kycStatus: 'KYC-Status',
      verified: 'Verifiziert',
      pending: 'In Prüfung',
      rejected: 'Abgelehnt',
      notSubmitted: 'Nicht eingereicht',
      changePassword: 'Passwort ändern',
      currentPassword: 'Aktuelles Passwort',
      newPassword: 'Neues Passwort',
      confirmPassword: 'Passwort bestätigen',
      language: 'Sprache',
      theme: 'Thema',
      dark: 'Dunkel',
      light: 'Hell',
      notifications: 'Benachrichtigungen',
      tickets: 'Support',
      createTicket: 'Neues Ticket',
      subject: 'Betreff',
      message: 'Nachricht',
      send: 'Senden',
      name: 'Vollständiger Name',
      phone: 'Telefonnummer',
      country: 'Land',
      saveChanges: 'Änderungen speichern',
      switchAccount: 'Konto wechseln',
      activeAccount: 'Aktives Konto',
      invalidCredentials: 'Ungültige Anmeldedaten — verwende die Demo-Konten unten',
      welcomeBack: 'Willkommen zurück',
      marketNews: 'Marktnachrichten',
      recentTransactions: 'Letzte Transaktionen',
      status: 'Status',
      date: 'Datum',
      type: 'Typ',
      completed: 'Abgeschlossen',
      processingStatus: 'Wird verarbeitet',
      pendingStatus: 'Ausstehend',
      failedStatus: 'Fehlgeschlagen',
      server: 'Server',
      leverage: 'Hebel',
      currency: 'Währung',
      accountType: 'Kontotyp',
      support: 'Support',
      analysis: 'Analysen',
      newTicket: 'Neues Ticket',
      newAccount: 'Neues Konto',
      myAccounts: 'Meine Konten',
      accountOverview: 'Kontoübersicht',
      quickActions: 'Schnellaktionen',
      funds: 'Gelder',
      security: 'Sicherheit',
      verification: 'Verifizierung',
      twoFactorAuth: 'Zwei-Faktor-Auth',
      enable: 'Aktivieren',
      disable: 'Deaktivieren',
      uploadDocument: 'Dokument hochladen',
      changeAvatar: 'Foto ändern',
      removeAvatar: 'Foto entfernen',
      open: 'Offen',
      inProgress: 'In Bearbeitung',
      resolved: 'Gelöst',
      closed: 'Geschlossen',
      low: 'Niedrig',
      medium: 'Mittel',
      high: 'Hoch',
      priority: 'Priorität',
      category: 'Kategorie',
      submitTicket: 'Ticket einreichen',
      typeMessage: 'Nachricht eingeben...',
      noTickets: 'Noch keine Tickets',
      describeIssue: 'Beschreibe dein Problem',
      marketInsights: 'Marktanalysen & Forschung',
      bullish: 'Bullisch',
      bearish: 'Bärisch',
      neutral: 'Neutral',
      readTime: 'Lesezeit',
      allLoaded: 'Alle Analysen geladen',
      loadingAnalyses: 'Analysen werden geladen...',
      goodMorning: 'Guten Morgen',
      goodAfternoon: 'Guten Nachmittag',
      goodEvening: 'Guten Abend',
      bank: 'Bank',
      selectPaymentMethod: 'Zahlungsmethode auswählen',
      walletAddress: 'Wallet-Adresse',
      networkWarning: 'Nur an dieses Netzwerk senden',
      copyAddress: 'Adresse kopieren',
      scanQR: 'QR-Code scannen',
      demoCredentials: 'Demo-Zugangsdaten',
      signIn: 'Anmelden',
      verifyCode: 'Code verifizieren',
      enterCode: 'Gib den 6-stelligen Code aus deiner Authenticator-App ein',
      backToLogin: 'Zurück zur Anmeldung',
      active: 'Aktiv',
      switch: 'Wechseln',
      // Register
      createAccount: 'Konto erstellen',
      fillDetails: 'Fülle die Details unten aus, um loszulegen.',
      fullNamePlaceholder: 'Max Mustermann',
      emailPlaceholder: 'deine@email.de',
      phonePlaceholder: '+49 (555) 000-0000',
      minCharsPlaceholder: 'Mind. 8 Zeichen',
      repeatPasswordPlaceholder: 'Passwort wiederholen',
      passwordWeak: 'Schwach',
      passwordMedium: 'Mittel',
      passwordStrong: 'Stark',
      creatingAccount: 'Konto wird erstellt...',
      alreadyHaveAccount: 'Bereits ein Konto?',
      dontHaveAccount: 'Noch kein Konto?',
      register: 'Registrieren',
      back: 'Zurück',
      // Forgot Password
      forgotPasswordTitle: 'Passwort vergessen?',
      forgotPasswordDesc:
        'Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen deines Passworts.',
      checkInbox: 'Überprüfe deinen Posteingang',
      resetLinkSent: 'Wir haben einen Reset-Link gesendet an',
      sendResetLink: 'Reset-Link senden',
      sending: 'Wird gesendet...',
      // Reset Password
      setNewPassword: 'Neues Passwort festlegen',
      setNewPasswordDesc:
        'Gib den Bestätigungscode aus deiner E-Mail ein und wähle ein neues Passwort.',
      verificationCode: 'Bestätigungscode',
      enterCodeFromEmail: 'Code aus E-Mail eingeben',
      passwordUpdated: 'Passwort aktualisiert!',
      canNowSignIn: 'Du kannst dich jetzt mit deinem neuen Passwort anmelden.',
      goToLogin: 'Zur Anmeldung',
      updating: 'Wird aktualisiert...',
      updatePassword: 'Passwort aktualisieren',
      // Login screen
      signInToAccount: 'Melde dich bei deinem Trading-Konto an',
      emailOrAccountId: 'E-Mail oder Konto-ID',
      enterYourPassword: 'Passwort eingeben',
      signingIn: 'Anmeldung läuft...',
      backToLoginLink: 'Zurück zur Anmeldung',
      twoFactorAuthTitle: 'Zwei-Faktor-Authentifizierung',
      enterSixDigitCode:
        'Gib den 6-stelligen Code aus deiner Authenticator-App ein, um fortzufahren.',
      authenticatorCode: 'Authenticator-Code',
      codeRequired: 'Code ist erforderlich',
      verifying: 'Wird verifiziert...',
      openAuthApp: 'Öffne deine Authenticator-App und gib den aktuellen 6-stelligen Code ein.',
      // Transactions
      tradingAccount: 'Handelskonto',
      selectTradingAccount: 'Handelskonto auswählen',
      availableBalance: 'Verfügbares Guthaben',
      selectDepositMethod: 'Einzahlungsmethode auswählen',
      selectWithdrawalMethod: 'Auszahlungsmethode auswählen',
      selectBankAccount: 'Bankkonto auswählen',
      selectCryptocurrency: 'Kryptowährung auswählen',
      bankDetails: 'Bankdaten',
      bankName: 'Bankname',
      accountHolderName: 'Kontoinhaber',
      accountNumber: 'Kontonummer',
      swiftBic: 'SWIFT/BIC',
      amountLabel: 'Betrag',
      submitDeposit: 'Einzahlung einreichen',
      submitWithdrawal: 'Auszahlung einreichen',
      noTransactions: 'Noch keine Transaktionen',
      creditIn: 'Krediteingang',
      creditOut: 'Kreditausgang',
      typeDeposit: 'Einzahlung',
      typeWithdraw: 'Auszahlung',
      sendToAddress: 'An Adresse senden',
      withdrawalAddress: 'Auszahlungsadresse',
      wrongAssetWarning: 'Das Senden falscher Assets führt zu dauerhaftem Verlust.',
      wireSwiftSepa: 'Überweisung / SWIFT / SEPA',
      btcEthUsdt: 'BTC, ETH, USDT & mehr',
      // Settings
      twoFAEnabled: 'Aktiviert — Google Authenticator',
      twoFADisabled: 'Deaktiviert — Aktivierung empfohlen',
      activeSessions: 'Aktive Sitzungen',
      pushNotifications: 'Push-Benachrichtigungen',
      tradeAlertsDesc: 'Handelswarnungen, Einzahlungen, Nachrichten',
      appVersion: 'App-Version',
      termsOfService: 'Nutzungsbedingungen',
      privacyPolicy: 'Datenschutzrichtlinie',
      contactSupport: 'Support kontaktieren',
      logOut: 'Abmelden',
      headerSettings: 'Einstellungen',
      headerLogout: 'Abmelden',
      logOutConfirmTitle: 'Abmelden',
      logOutConfirmMsg:
        'Bist du sicher, dass du dich von application abmelden möchtest? Deine offenen Positionen werden nicht beeinflusst.',
      stay: 'Bleiben',
      updatePasswordBtn: 'Passwort aktualisieren',
      saveChangesBtn: 'Änderungen speichern',
      kycStatusLabel: 'KYC-Status',
      dropFileHere: 'Datei hier ablegen oder zum Hochladen tippen',
      fileFormats: 'JPG, PNG, PDF — max 10MB',
      uploading: 'Wird hochgeladen...',
      uploaded: 'Hochgeladen',
      docsReviewTime: 'Dokumente werden innerhalb von 1–3 Werktagen geprüft.',
      step1InstallAuth: 'Schritt 1: Authenticator installieren',
      downloadAuthApp: 'Lade eine Authenticator-App herunter',
      step1Desc:
        'Installiere Google Authenticator oder Authy auf deinem Mobilgerät. Diese Apps generieren zeitbasierte Einmalpasswörter (TOTP), um dein Konto zu sichern.',
      iHaveApp: 'Ich habe die App — Weiter',
      step2ScanQR: 'Schritt 2: QR-Code scannen',
      scanWithApp: 'Mit deiner Authenticator-App scannen',
      enterManually: 'Oder gib den geheimen Schlüssel manuell ein:',
      enter6DigitVerify: '6-stelligen Code zur Verifizierung eingeben',
      verifyEnable: 'Verifizieren & Aktivieren',
      twoFADisabledMsg: '2FA deaktiviert — dein Konto ist weniger sicher.',
      twoFAEnabledTitle: '2FA aktiviert!',
      twoFAEnabledDesc:
        'Die Zwei-Faktor-Authentifizierung ist jetzt aktiv. Speichere deine Backup-Codes an einem sicheren Ort.',
      doneSaveBackup: 'Fertig — Backup-Codes speichern',
      currentSession: 'Aktuell',
      revoke: 'Widerrufen',
      preferences: 'Einstellungen',
      // Sub Accounts
      newAccountBtn: 'Neues Konto',
      createNewAccount: 'Neues Konto erstellen',
      accountTypeLabel: 'Kontotyp',
      summary: 'Zusammenfassung',
      demoDesc: 'Mit virtuellem Geld üben',
      realDesc: 'Mit echtem Geld handeln',
      creating: 'Wird erstellt...',
      createAccountBtn: 'Konto erstellen',
      noTradingAccounts: 'Keine Handelskonten',
      createToGetStarted: 'Erstelle ein neues Konto, um loszulegen',
      switchAccountTitle: 'Konto wechseln',
      switchAccountMsg: 'Zu Konto #{{id}} wechseln? Deine aktive Sitzung wird aktualisiert.',
      // Support
      ticketCount: '{{count}} Ticket',
      ticketCountPlural: '{{count}} Tickets',
      briefDescription: 'Kurze Beschreibung deines Problems',
      selectCategory: 'Kategorie auswählen',
      describeInDetail: 'Beschreibe dein Problem im Detail...',
      ticketCreated: 'Ticket {{id}} erfolgreich erstellt',
      ticketClosed:
        'Dieses Ticket ist {{status}}. Öffne ein neues Ticket, wenn du weitere Hilfe benötigst.',
      updatedAt: 'Aktualisiert {{time}}',
      // Analysis
      analysisTitle: 'Analysen',
      analysisDirection: 'Richtung',
      analysisBuy: 'Kauf',
      analysisSell: 'Verkauf',
      analysisBuySell: 'Kauf / Verkauf',
      analysisDescription: 'Beschreibung',
      analysisTags: 'Tags',
      analysisEntry: 'Einstieg',
      analysisSL: 'Stop-Loss',
      analysisTP1: 'TP 1',
      analysisTP2: 'TP 2',
      analysisTP3: 'TP 3',
      // Dashboard
      goodEvening2: 'Guten Abend 👋',
      // Notifications
      notificationsTitle: 'Benachrichtigungen',
      markAllRead: 'Alle als gelesen markieren',
      noNotifications: 'Keine Benachrichtigungen',
      read: 'Gelesen',
      unread: 'Ungelesen',
      // Bottom Nav
      navDashboard: 'Dashboard',
      navTrade: 'Handel',
      navFunds: 'Gelder',
      navAccounts: 'Konten',
      navAnalysis: 'Analysen',
      navSettings: 'Einstellungen',
      // Metric Cards
      atRisk: 'Gefährdet',
      // TopHeader
      darkModeEnabled: 'Dunkelmodus aktiviert',
      lightModeEnabled: 'Hellmodus aktiviert',
      languageChanged: 'Sprache auf {{lang}} geändert',
      // PWA
      pwaInstallTitle: 'App installieren',
      pwaInstallMsg: 'Zum schnellen Zugriff zum Startbildschirm hinzufügen',
      pwaInstall: 'Installieren',
      pwaDismiss: 'Nicht erneut anzeigen',
      pwaHowToTitle: 'Auf dem Gerät installieren',
      pwaHowToSubtitle: 'Folge den Schritten für deine Plattform',
      pwaIos: 'iOS',
      pwaAndroid: 'Android',
      pwaIosStep1: 'Öffne diese Seite in Safari',
      pwaIosStep2: 'Tippe unten auf die Teilen-Taste',
      pwaIosStep3: 'Scrolle nach unten und tippe auf Zum Home-Bildschirm',
      pwaIosStep4: 'Tippe oben rechts auf Hinzufügen',
      pwaAndroidStep1: 'Öffne diese Seite in Chrome',
      pwaAndroidStep2: 'Tippe oben rechts auf das Drei-Punkte-Menü',
      pwaAndroidStep3: 'Tippe auf App installieren oder Zum Startbildschirm hinzufügen',
      pwaAndroidStep4: 'Tippe auf Installieren, um zu bestätigen',
      pwaGotIt: 'Verstanden',
      allNewsLoaded: 'Alle Nachrichten geladen',
      loadMore: 'Mehr laden',
      amountUSD: 'Betrag (USD)',
      avatarUpdated: 'Profilfoto aktualisiert',
      disable2FATitle: '2FA deaktivieren',
      disable2FAWarningTitle: 'Dein Konto wird weniger sicher',
      disable2FAWarningDesc:
        'Das Deaktivieren der Zwei-Faktor-Authentifizierung verringert den Schutz deines Kontos. Jeder mit deinem Passwort könnte sich anmelden.',
      kycIdentityFront: 'Ausweisdokument — Vorderseite',
      kycIdentityBack: 'Ausweisdokument — Rückseite',
      kycProofAddress: 'Adressnachweis',
      kycDocApprovedTitle: 'Genehmigt',
      kycDocApprovedDesc: 'Dieses Dokument wurde geprüft und genehmigt.',
      minChars: 'Mindestens 8 Zeichen',
      mustIncludeUpperNum: 'Muss einen Großbuchstaben und eine Zahl enthalten',
      passwordChanged: 'Passwort erfolgreich geändert',
      passwordChangeFailed: 'Passwort konnte nicht geändert werden',
      passwordsNoMatch: 'Passwörter stimmen nicht überein',
      profileUpdated: 'Profil aktualisiert',
      profileUpdateFailed: 'Profil konnte nicht aktualisiert werden',
      required: 'Erforderlich',
      searchCountry: 'Land suchen',
      setupStepsTitle: 'Einrichtungsschritte',
      setup2FAStep1: 'Installiere Google Authenticator oder Authy auf deinem Handy',
      setup2FAStep2: 'Scanne den QR-Code oder gib den geheimen Schlüssel ein',
      setup2FAStep3: 'Gib den 6-stelligen Code ein, um 2FA zu aktivieren',
      removeStepsTitle: 'So deaktivieren',
      remove2FAStep1: 'Öffne deine Authenticator-App',
      remove2FAStep2: 'Gib den aktuellen 6-stelligen Code ein',
      remove2FAStep3: 'Bestätige, um die Zwei-Faktor-Authentifizierung zu deaktivieren',
      twoFADisableFailed: '2FA konnte nicht deaktiviert werden',
      uploadedSuccess: '{{label}} erfolgreich hochgeladen',
      termsContent:
        'Durch die Nutzung dieser Anwendung stimmst du diesen Nutzungsbedingungen zu. Du musst in deiner Rechtsordnung volljährig sein und bist für die Vertraulichkeit deiner Zugangsdaten verantwortlich. Der Handel birgt ein erhebliches Verlustrisiko und ist nicht für jeden Anleger geeignet. Wir können den Zugang bei Verdacht auf Betrug, Marktmissbrauch oder Verstoß gegen diese Bedingungen sperren oder beenden. Bei Fragen wende dich an den Support.',
      privacyContent:
        'Wir erheben und verarbeiten personenbezogene Daten, die zur Führung deines Kontos, zur Verifizierung und zur Bereitstellung von Handelsdienstleistungen erforderlich sind. Dazu können Identitätsdaten, Kontaktdaten und der Transaktionsverlauf gehören. Daten werden sicher gespeichert und nur weitergegeben, wenn es gesetzlich vorgeschrieben oder für die Leistungserbringung nötig ist. Du kannst Auskunft, Berichtigung oder Löschung deiner Daten über den Support verlangen.',
    },
  },
  zh: {
    translation: {
      login: '登录',
      email: '电子邮件',
      password: '密码',
      forgotPassword: '忘记密码？',
      rememberMe: '记住我',
      twoFA: '双因素认证',
      twoFACode: '6位验证码',
      liveAccount: '真实账户',
      demoAccount: '模拟账户',
      balance: '余额',
      equity: '净值',
      deposit: '入金',
      withdraw: '出金',
      noData: '未找到数据',
      loading: '加载中...',
      dashboard: '仪表板',
      trade: '交易',
      transactions: '交易记录',
      accounts: '账户',
      settings: '设置',
      margin: '已用保证金',
      freeMargin: '可用保证金',
      marginLevel: '保证金水平',
      openPL: '浮动盈亏',
      history: '历史',
      amount: '金额',
      paymentMethod: '支付方式',
      bankTransfer: '银行转账',
      creditCard: '信用卡/借记卡',
      crypto: '加密货币',
      submit: '提交',
      cancel: '取消',
      confirm: '确认',
      logout: '退出登录',
      profile: '个人资料',
      kycStatus: 'KYC状态',
      verified: '已验证',
      pending: '审核中',
      rejected: '已拒绝',
      notSubmitted: '未提交',
      changePassword: '修改密码',
      currentPassword: '当前密码',
      newPassword: '新密码',
      confirmPassword: '确认密码',
      language: '语言',
      theme: '主题',
      dark: '深色',
      light: '浅色',
      notifications: '通知',
      tickets: '支持',
      createTicket: '新建工单',
      subject: '主题',
      message: '消息',
      send: '发送',
      name: '全名',
      phone: '电话号码',
      country: '国家',
      saveChanges: '保存更改',
      switchAccount: '切换账户',
      activeAccount: '当前账户',
      invalidCredentials: '凭据无效 — 请使用下方演示账户登录',
      welcomeBack: '欢迎回来',
      marketNews: '市场新闻',
      recentTransactions: '最近交易',
      status: '状态',
      date: '日期',
      type: '类型',
      completed: '已完成',
      processingStatus: '处理中',
      pendingStatus: '待处理',
      failedStatus: '失败',
      server: '服务器',
      leverage: '杠杆',
      currency: '货币',
      accountType: '账户类型',
      support: '支持',
      analysis: '分析',
      newTicket: '新建工单',
      newAccount: '新建账户',
      myAccounts: '我的账户',
      accountOverview: '账户概览',
      quickActions: '快捷操作',
      funds: '资金',
      security: '安全',
      verification: '验证',
      twoFactorAuth: '双因素认证',
      enable: '启用',
      disable: '禁用',
      uploadDocument: '上传文件',
      changeAvatar: '更换头像',
      removeAvatar: '删除头像',
      open: '开放',
      inProgress: '处理中',
      resolved: '已解决',
      closed: '已关闭',
      low: '低',
      medium: '中',
      high: '高',
      priority: '优先级',
      category: '类别',
      submitTicket: '提交工单',
      typeMessage: '输入消息...',
      noTickets: '暂无工单',
      describeIssue: '描述您的问题',
      marketInsights: '市场洞察与研究',
      bullish: '看涨',
      bearish: '看跌',
      neutral: '中性',
      readTime: '阅读',
      allLoaded: '所有分析已加载',
      loadingAnalyses: '正在加载分析...',
      goodMorning: '早上好',
      goodAfternoon: '下午好',
      goodEvening: '晚上好',
      bank: '银行',
      selectPaymentMethod: '选择支付方式',
      walletAddress: '钱包地址',
      networkWarning: '仅发送到此网络',
      copyAddress: '复制地址',
      scanQR: '扫描二维码',
      demoCredentials: '演示账户凭据',
      signIn: '登录',
      verifyCode: '验证码',
      enterCode: '输入验证器应用中的6位验证码',
      backToLogin: '返回登录',
      active: '活跃',
      switch: '切换',
      // Register
      createAccount: '创建账户',
      fillDetails: '填写以下详细信息以开始。',
      fullNamePlaceholder: '张三',
      emailPlaceholder: 'your@email.com',
      phonePlaceholder: '+86 (555) 000-0000',
      minCharsPlaceholder: '最少8个字符',
      repeatPasswordPlaceholder: '重复您的密码',
      passwordWeak: '弱',
      passwordMedium: '中',
      passwordStrong: '强',
      creatingAccount: '正在创建账户...',
      alreadyHaveAccount: '已有账户？',
      dontHaveAccount: '没有账户？',
      register: '注册',
      back: '返回',
      // Forgot Password
      forgotPasswordTitle: '忘记密码？',
      forgotPasswordDesc: '输入您的电子邮件地址，我们将向您发送重置密码的链接。',
      checkInbox: '检查您的收件箱',
      resetLinkSent: '我们已发送重置链接至',
      sendResetLink: '发送重置链接',
      sending: '发送中...',
      // Reset Password
      setNewPassword: '设置新密码',
      setNewPasswordDesc: '输入您邮件中的验证码并选择新密码。',
      verificationCode: '验证码',
      enterCodeFromEmail: '输入邮件中的验证码',
      passwordUpdated: '密码已更新！',
      canNowSignIn: '您现在可以使用新密码登录。',
      goToLogin: '前往登录',
      updating: '更新中...',
      updatePassword: '更新密码',
      // Login screen
      signInToAccount: '登录您的交易账户',
      emailOrAccountId: '电子邮件或账户ID',
      enterYourPassword: '输入您的密码',
      signingIn: '登录中...',
      backToLoginLink: '返回登录',
      twoFactorAuthTitle: '双因素认证',
      enterSixDigitCode: '输入验证器应用中的6位验证码以继续。',
      authenticatorCode: '验证器代码',
      codeRequired: '需要验证码',
      verifying: '验证中...',
      openAuthApp: '打开您的验证器应用并输入当前的6位验证码。',
      // Transactions
      tradingAccount: '交易账户',
      selectTradingAccount: '选择交易账户',
      availableBalance: '可用余额',
      selectDepositMethod: '选择入金方式',
      selectWithdrawalMethod: '选择出金方式',
      selectBankAccount: '选择银行账户',
      selectCryptocurrency: '选择加密货币',
      bankDetails: '银行详情',
      bankName: '银行名称',
      accountHolderName: '账户持有人姓名',
      accountNumber: '账户号码',
      swiftBic: 'SWIFT/BIC',
      amountLabel: '金额',
      submitDeposit: '提交入金',
      submitWithdrawal: '提交出金',
      noTransactions: '暂无交易记录',
      creditIn: '额度转入',
      creditOut: '额度转出',
      typeDeposit: '入金',
      typeWithdraw: '出金',
      sendToAddress: '发送到地址',
      withdrawalAddress: '出金地址',
      wrongAssetWarning: '发送错误资产将导致永久损失。',
      wireSwiftSepa: '电汇 / SWIFT / SEPA',
      btcEthUsdt: 'BTC、ETH、USDT等',
      // Settings
      twoFAEnabled: '已启用 — Google Authenticator',
      twoFADisabled: '已禁用 — 建议启用',
      activeSessions: '活跃会话',
      pushNotifications: '推送通知',
      tradeAlertsDesc: '交易提醒、入金、新闻',
      appVersion: '应用版本',
      termsOfService: '服务条款',
      privacyPolicy: '隐私政策',
      contactSupport: '联系支持',
      logOut: '退出登录',
      headerSettings: '设置',
      headerLogout: '退出登录',
      logOutConfirmTitle: '退出登录',
      logOutConfirmMsg: '您确定要退出该应用吗？您的未平仓头寸不会受到影响。',
      stay: '留下',
      updatePasswordBtn: '更新密码',
      saveChangesBtn: '保存更改',
      kycStatusLabel: 'KYC状态',
      dropFileHere: '将文件拖放到此处或点击上传',
      fileFormats: 'JPG、PNG、PDF — 最大10MB',
      uploading: '上传中...',
      uploaded: '已上传',
      docsReviewTime: '文件将在1–3个工作日内审核。',
      step1InstallAuth: '第1步：安装验证器',
      downloadAuthApp: '下载验证器应用',
      step1Desc:
        '在您的移动设备上安装Google Authenticator或Authy。这些应用程序生成基于时间的一次性密码（TOTP）来保护您的账户。',
      iHaveApp: '我有应用 — 继续',
      step2ScanQR: '第2步：扫描二维码',
      scanWithApp: '使用您的验证器应用扫描',
      enterManually: '或手动输入密钥：',
      enter6DigitVerify: '输入6位验证码进行验证',
      verifyEnable: '验证并启用',
      twoFADisabledMsg: '2FA已禁用 — 您的账户安全性较低。',
      twoFAEnabledTitle: '2FA已启用！',
      twoFAEnabledDesc: '双因素认证现已激活。请将备份代码保存在安全的地方。',
      doneSaveBackup: '完成 — 保存备份代码',
      currentSession: '当前',
      revoke: '撤销',
      preferences: '偏好设置',
      // Sub Accounts
      newAccountBtn: '新建账户',
      createNewAccount: '创建新账户',
      accountTypeLabel: '账户类型',
      summary: '摘要',
      demoDesc: '使用虚拟资金练习',
      realDesc: '使用真实资金交易',
      creating: '创建中...',
      createAccountBtn: '创建账户',
      noTradingAccounts: '没有交易账户',
      createToGetStarted: '创建新账户以开始',
      switchAccountTitle: '切换账户',
      switchAccountMsg: '切换到账户 #{{id}}？您的活跃会话将被更新。',
      // Support
      ticketCount: '{{count}} 个工单',
      ticketCountPlural: '{{count}} 个工单',
      briefDescription: '问题的简短描述',
      selectCategory: '选择类别',
      describeInDetail: '详细描述您的问题...',
      ticketCreated: '工单 {{id}} 创建成功',
      ticketClosed: '此工单已{{status}}。如需进一步帮助，请开启新工单。',
      updatedAt: '更新于 {{time}}',
      // Analysis
      analysisTitle: '分析',
      analysisDirection: '方向',
      analysisBuy: '买入',
      analysisSell: '卖出',
      analysisBuySell: '买入 / 卖出',
      analysisDescription: '描述',
      analysisTags: '标签',
      analysisEntry: '入场',
      analysisSL: '止损',
      analysisTP1: '止盈 1',
      analysisTP2: '止盈 2',
      analysisTP3: '止盈 3',
      // Dashboard
      goodEvening2: '晚上好 👋',
      // Notifications
      notificationsTitle: '通知',
      markAllRead: '全部标为已读',
      noNotifications: '没有通知',
      read: '已读',
      unread: '未读',
      // Bottom Nav
      navDashboard: '仪表板',
      navTrade: '交易',
      navFunds: '资金',
      navAccounts: '账户',
      navAnalysis: '分析',
      navSettings: '设置',
      // Metric Cards
      atRisk: '风险',
      // TopHeader
      darkModeEnabled: '深色模式已启用',
      lightModeEnabled: '浅色模式已启用',
      languageChanged: '语言已更改为 {{lang}}',
      // PWA
      pwaInstallTitle: '安装应用',
      pwaInstallMsg: '添加到主屏幕以便快速访问',
      pwaInstall: '安装',
      pwaDismiss: '不再显示',
      pwaHowToTitle: '安装到您的设备',
      pwaHowToSubtitle: '按照您的平台步骤操作',
      pwaIos: 'iOS',
      pwaAndroid: 'Android',
      pwaIosStep1: '在 Safari 中打开此页面',
      pwaIosStep2: '点击屏幕底部的分享按钮',
      pwaIosStep3: '向下滚动并点击“添加到主屏幕”',
      pwaIosStep4: '点击右上角的“添加”',
      pwaAndroidStep1: '在 Chrome 中打开此页面',
      pwaAndroidStep2: '点击右上角的三点菜单',
      pwaAndroidStep3: '点击“安装应用”或“添加到主屏幕”',
      pwaAndroidStep4: '点击“安装”以确认',
      pwaGotIt: '知道了',
      allNewsLoaded: '全部新闻已加载',
      loadMore: '加载更多',
      amountUSD: '金额（美元）',
      avatarUpdated: '头像已更新',
      disable2FATitle: '关闭双重验证',
      disable2FAWarningTitle: '您的账户安全性将降低',
      disable2FAWarningDesc:
        '关闭双重验证会降低账户保护。任何知道您密码的人都可能登录。',
      kycIdentityFront: '身份证件 — 正面',
      kycIdentityBack: '身份证件 — 背面',
      kycProofAddress: '地址证明',
      kycDocApprovedTitle: '已批准',
      kycDocApprovedDesc: '该文件已通过验证并获批准。',
      minChars: '至少8个字符',
      mustIncludeUpperNum: '必须包含一个大写字母和一个数字',
      passwordChanged: '密码已成功更改',
      passwordChangeFailed: '密码更改失败',
      passwordsNoMatch: '两次输入的密码不一致',
      profileUpdated: '个人资料已更新',
      profileUpdateFailed: '个人资料更新失败',
      required: '必填',
      searchCountry: '搜索国家',
      setupStepsTitle: '设置步骤',
      setup2FAStep1: '在手机上安装 Google Authenticator 或 Authy',
      setup2FAStep2: '扫描二维码或输入密钥',
      setup2FAStep3: '输入6位验证码以启用双重验证',
      removeStepsTitle: '如何关闭',
      remove2FAStep1: '打开您的验证器应用',
      remove2FAStep2: '输入当前的6位验证码',
      remove2FAStep3: '确认以关闭双重验证',
      twoFADisableFailed: '无法关闭双重验证',
      uploadedSuccess: '{{label}} 上传成功',
      termsContent:
        '使用本应用即表示您同意本服务条款。您必须在所在司法管辖区达到法定年龄，并负责妥善保管账户凭证。交易存在重大亏损风险，并不适合所有投资者。如涉嫌欺诈、市场滥用或违反本条款，我们可能暂停或终止访问。如有疑问，请联系客服。',
      privacyContent:
        '我们收集并处理运营账户、完成验证和提供交易服务所需的个人数据。这可能包括身份信息、联系方式和交易记录。数据会被安全存储，仅在法律要求或提供服务所必需时共享。您可通过客服申请查阅、更正或删除您的数据。',
    },
  },
  ar: {
    translation: {
      login: 'تسجيل الدخول',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      forgotPassword: 'نسيت كلمة المرور؟',
      rememberMe: 'تذكرني',
      twoFA: 'المصادقة الثنائية',
      twoFACode: 'رمز مكون من 6 أرقام',
      liveAccount: 'حساب حقيقي',
      demoAccount: 'حساب تجريبي',
      balance: 'الرصيد',
      equity: 'حقوق الملكية',
      deposit: 'إيداع',
      withdraw: 'سحب',
      noData: 'لا توجد بيانات',
      loading: 'جار التحميل...',
      dashboard: 'لوحة التحكم',
      trade: 'تداول',
      transactions: 'المعاملات',
      accounts: 'الحسابات',
      settings: 'الإعدادات',
      margin: 'الهامش المستخدم',
      freeMargin: 'الهامش الحر',
      marginLevel: 'مستوى الهامش',
      openPL: 'الربح/الخسارة المفتوح',
      history: 'السجل',
      amount: 'المبلغ',
      paymentMethod: 'طريقة الدفع',
      bankTransfer: 'تحويل بنكي',
      creditCard: 'بطاقة ائتمان / خصم',
      crypto: 'عملة مشفرة',
      submit: 'إرسال',
      cancel: 'إلغاء',
      confirm: 'تأكيد',
      logout: 'تسجيل الخروج',
      profile: 'الملف الشخصي',
      kycStatus: 'حالة KYC',
      verified: 'تم التحقق',
      pending: 'قيد المراجعة',
      rejected: 'مرفوض',
      notSubmitted: 'لم يُقدَّم',
      changePassword: 'تغيير كلمة المرور',
      currentPassword: 'كلمة المرور الحالية',
      newPassword: 'كلمة المرور الجديدة',
      confirmPassword: 'تأكيد كلمة المرور',
      language: 'اللغة',
      theme: 'المظهر',
      dark: 'داكن',
      light: 'فاتح',
      notifications: 'الإشعارات',
      tickets: 'الدعم',
      createTicket: 'تذكرة جديدة',
      subject: 'الموضوع',
      message: 'الرسالة',
      send: 'إرسال',
      name: 'الاسم الكامل',
      phone: 'رقم الهاتف',
      country: 'الدولة',
      saveChanges: 'حفظ التغييرات',
      switchAccount: 'تبديل الحساب',
      activeAccount: 'الحساب النشط',
      invalidCredentials: 'بيانات اعتماد غير صالحة — استخدم الحسابات التجريبية للدخول',
      welcomeBack: 'مرحباً بعودتك',
      marketNews: 'أخبار السوق',
      recentTransactions: 'المعاملات الأخيرة',
      status: 'الحالة',
      date: 'التاريخ',
      type: 'النوع',
      completed: 'مكتمل',
      processingStatus: 'قيد المعالجة',
      pendingStatus: 'معلق',
      failedStatus: 'فشل',
      server: 'الخادم',
      leverage: 'الرافعة المالية',
      currency: 'العملة',
      accountType: 'نوع الحساب',
      support: 'الدعم',
      analysis: 'التحليلات',
      newTicket: 'تذكرة جديدة',
      newAccount: 'حساب جديد',
      myAccounts: 'حساباتي',
      accountOverview: 'نظرة عامة على الحساب',
      quickActions: 'الإجراءات السريعة',
      funds: 'الأموال',
      security: 'الأمان',
      verification: 'التحقق',
      twoFactorAuth: 'المصادقة الثنائية',
      enable: 'تفعيل',
      disable: 'تعطيل',
      uploadDocument: 'رفع مستند',
      changeAvatar: 'تغيير الصورة',
      removeAvatar: 'إزالة الصورة',
      open: 'مفتوح',
      inProgress: 'قيد التنفيذ',
      resolved: 'تم الحل',
      closed: 'مغلق',
      low: 'منخفض',
      medium: 'متوسط',
      high: 'عالي',
      priority: 'الأولوية',
      category: 'الفئة',
      submitTicket: 'إرسال التذكرة',
      typeMessage: 'اكتب رسالة...',
      noTickets: 'لا توجد تذاكر بعد',
      describeIssue: 'صف مشكلتك',
      marketInsights: 'رؤى السوق والبحوث',
      bullish: 'صاعد',
      bearish: 'هابط',
      neutral: 'محايد',
      readTime: 'قراءة',
      allLoaded: 'تم تحميل جميع التحليلات',
      loadingAnalyses: 'جار تحميل التحليلات...',
      goodMorning: 'صباح الخير',
      goodAfternoon: 'مساء الخير',
      goodEvening: 'مساء النور',
      bank: 'بنك',
      selectPaymentMethod: 'اختر طريقة الدفع',
      walletAddress: 'عنوان المحفظة',
      networkWarning: 'أرسل فقط إلى هذه الشبكة',
      copyAddress: 'نسخ العنوان',
      scanQR: 'مسح رمز QR',
      demoCredentials: 'بيانات الحساب التجريبي',
      signIn: 'تسجيل الدخول',
      verifyCode: 'التحقق من الرمز',
      enterCode: 'أدخل الرمز المكون من 6 أرقام من تطبيق المصادقة',
      backToLogin: 'العودة لتسجيل الدخول',
      active: 'نشط',
      switch: 'تبديل',
      // Register
      createAccount: 'إنشاء حساب',
      fillDetails: 'أدخل التفاصيل أدناه للبدء.',
      fullNamePlaceholder: 'محمد أحمد',
      emailPlaceholder: 'your@email.com',
      phonePlaceholder: '+966 (555) 000-0000',
      minCharsPlaceholder: 'الحد الأدنى 8 أحرف',
      repeatPasswordPlaceholder: 'أعد إدخال كلمة المرور',
      passwordWeak: 'ضعيفة',
      passwordMedium: 'متوسطة',
      passwordStrong: 'قوية',
      creatingAccount: 'جار إنشاء الحساب...',
      alreadyHaveAccount: 'لديك حساب بالفعل؟',
      dontHaveAccount: 'ليس لديك حساب؟',
      register: 'تسجيل',
      back: 'رجوع',
      // Forgot Password
      forgotPasswordTitle: 'نسيت كلمة المرور؟',
      forgotPasswordDesc: 'أدخل عنوان بريدك الإلكتروني وسنرسل لك رابطاً لإعادة تعيين كلمة المرور.',
      checkInbox: 'تحقق من صندوق الوارد',
      resetLinkSent: 'أرسلنا رابط إعادة التعيين إلى',
      sendResetLink: 'إرسال رابط إعادة التعيين',
      sending: 'جار الإرسال...',
      // Reset Password
      setNewPassword: 'تعيين كلمة مرور جديدة',
      setNewPasswordDesc: 'أدخل رمز التحقق من بريدك الإلكتروني واختر كلمة مرور جديدة.',
      verificationCode: 'رمز التحقق',
      enterCodeFromEmail: 'أدخل الرمز من البريد الإلكتروني',
      passwordUpdated: 'تم تحديث كلمة المرور!',
      canNowSignIn: 'يمكنك الآن تسجيل الدخول بكلمة مرورك الجديدة.',
      goToLogin: 'الذهاب لتسجيل الدخول',
      updating: 'جار التحديث...',
      updatePassword: 'تحديث كلمة المرور',
      // Login screen
      signInToAccount: 'سجل الدخول إلى حساب التداول الخاص بك',
      emailOrAccountId: 'البريد الإلكتروني أو معرف الحساب',
      enterYourPassword: 'أدخل كلمة مرورك',
      signingIn: 'جار تسجيل الدخول...',
      backToLoginLink: 'العودة لتسجيل الدخول',
      twoFactorAuthTitle: 'المصادقة الثنائية',
      enterSixDigitCode: 'أدخل الرمز المكون من 6 أرقام من تطبيق المصادقة للمتابعة.',
      authenticatorCode: 'رمز المصادقة',
      codeRequired: 'الرمز مطلوب',
      verifying: 'جار التحقق...',
      openAuthApp: 'افتح تطبيق المصادقة وأدخل الرمز الحالي المكون من 6 أرقام.',
      // Transactions
      tradingAccount: 'حساب التداول',
      selectTradingAccount: 'اختر حساب التداول',
      availableBalance: 'الرصيد المتاح',
      selectDepositMethod: 'اختر طريقة الإيداع',
      selectWithdrawalMethod: 'اختر طريقة السحب',
      selectBankAccount: 'اختر الحساب البنكي',
      selectCryptocurrency: 'اختر العملة المشفرة',
      bankDetails: 'تفاصيل البنك',
      bankName: 'اسم البنك',
      accountHolderName: 'اسم صاحب الحساب',
      accountNumber: 'رقم الحساب',
      swiftBic: 'SWIFT/BIC',
      amountLabel: 'المبلغ',
      submitDeposit: 'إرسال طلب الإيداع',
      submitWithdrawal: 'إرسال طلب السحب',
      noTransactions: 'لا توجد معاملات بعد',
      creditIn: 'إدخال رصيد',
      creditOut: 'إخراج رصيد',
      typeDeposit: 'إيداع',
      typeWithdraw: 'سحب',
      sendToAddress: 'إرسال إلى العنوان',
      withdrawalAddress: 'عنوان السحب',
      wrongAssetWarning: 'إرسال أصول خاطئة سيؤدي إلى خسارة دائمة.',
      wireSwiftSepa: 'تحويل / SWIFT / SEPA',
      btcEthUsdt: 'BTC، ETH، USDT والمزيد',
      // Settings
      twoFAEnabled: 'مفعّل — Google Authenticator',
      twoFADisabled: 'معطّل — يُنصح بالتفعيل',
      activeSessions: 'الجلسات النشطة',
      pushNotifications: 'الإشعارات الفورية',
      tradeAlertsDesc: 'تنبيهات التداول والإيداعات والأخبار',
      appVersion: 'إصدار التطبيق',
      termsOfService: 'شروط الخدمة',
      privacyPolicy: 'سياسة الخصوصية',
      contactSupport: 'التواصل مع الدعم',
      logOut: 'تسجيل الخروج',
      headerSettings: 'الإعدادات',
      headerLogout: 'تسجيل الخروج',
      logOutConfirmTitle: 'تسجيل الخروج',
      logOutConfirmMsg:
        'هل أنت متأكد من رغبتك في تسجيل الخروج من application؟ لن تتأثر صفقاتك المفتوحة.',
      stay: 'البقاء',
      updatePasswordBtn: 'تحديث كلمة المرور',
      saveChangesBtn: 'حفظ التغييرات',
      kycStatusLabel: 'حالة KYC',
      dropFileHere: 'أسقط الملف هنا أو انقر للرفع',
      fileFormats: 'JPG، PNG، PDF — الحد الأقصى 10MB',
      uploading: 'جار الرفع...',
      uploaded: 'تم الرفع',
      docsReviewTime: 'تتم مراجعة المستندات خلال 1–3 أيام عمل.',
      step1InstallAuth: 'الخطوة 1: تثبيت تطبيق المصادقة',
      downloadAuthApp: 'قم بتنزيل تطبيق مصادقة',
      step1Desc:
        'قم بتثبيت Google Authenticator أو Authy على جهازك المحمول. تولد هذه التطبيقات كلمات مرور لمرة واحدة مستندة إلى الوقت (TOTP) لتأمين حسابك.',
      iHaveApp: 'لدي التطبيق — متابعة',
      step2ScanQR: 'الخطوة 2: مسح رمز QR',
      scanWithApp: 'امسح باستخدام تطبيق المصادقة',
      enterManually: 'أو أدخل المفتاح السري يدوياً:',
      enter6DigitVerify: 'أدخل الرمز المكون من 6 أرقام للتحقق',
      verifyEnable: 'تحقق وتفعيل',
      twoFADisabledMsg: 'تم تعطيل المصادقة الثنائية — حسابك أقل أماناً.',
      twoFAEnabledTitle: 'تم تفعيل المصادقة الثنائية!',
      twoFAEnabledDesc: 'المصادقة الثنائية نشطة الآن. احفظ رموز النسخ الاحتياطي في مكان آمن.',
      doneSaveBackup: 'تم — حفظ رموز النسخ الاحتياطي',
      currentSession: 'الحالية',
      revoke: 'إلغاء',
      preferences: 'التفضيلات',
      // Sub Accounts
      newAccountBtn: 'حساب جديد',
      createNewAccount: 'إنشاء حساب جديد',
      accountTypeLabel: 'نوع الحساب',
      summary: 'ملخص',
      demoDesc: 'تدرب بأموال افتراضية',
      realDesc: 'تداول بأموال حقيقية',
      creating: 'جار الإنشاء...',
      createAccountBtn: 'إنشاء حساب',
      noTradingAccounts: 'لا توجد حسابات تداول',
      createToGetStarted: 'أنشئ حساباً جديداً للبدء',
      switchAccountTitle: 'تبديل الحساب',
      switchAccountMsg: 'التبديل إلى الحساب #{{id}}؟ سيتم تحديث جلستك النشطة.',
      // Support
      ticketCount: '{{count}} تذكرة',
      ticketCountPlural: '{{count}} تذاكر',
      briefDescription: 'وصف موجز لمشكلتك',
      selectCategory: 'اختر الفئة',
      describeInDetail: 'صف مشكلتك بالتفصيل...',
      ticketCreated: 'تم إنشاء التذكرة {{id}} بنجاح',
      ticketClosed: 'هذه التذكرة {{status}}. افتح تذكرة جديدة إذا كنت بحاجة إلى مزيد من المساعدة.',
      updatedAt: 'تم التحديث {{time}}',
      // Analysis
      analysisTitle: 'التحليلات',
      analysisDirection: 'الاتجاه',
      analysisBuy: 'شراء',
      analysisSell: 'بيع',
      analysisBuySell: 'شراء / بيع',
      analysisDescription: 'الوصف',
      analysisTags: 'الوسوم',
      analysisEntry: 'الدخول',
      analysisSL: 'وقف الخسارة',
      analysisTP1: 'TP 1',
      analysisTP2: 'TP 2',
      analysisTP3: 'TP 3',
      // Dashboard
      goodEvening2: 'مساء الخير 👋',
      // Notifications
      notificationsTitle: 'الإشعارات',
      markAllRead: 'تحديد الكل كمقروء',
      noNotifications: 'لا توجد إشعارات',
      read: 'مقروء',
      unread: 'غير مقروء',
      // Bottom Nav
      navDashboard: 'لوحة التحكم',
      navTrade: 'تداول',
      navFunds: 'الأموال',
      navAccounts: 'الحسابات',
      navAnalysis: 'التحليلات',
      navSettings: 'الإعدادات',
      // Metric Cards
      atRisk: 'في خطر',
      // TopHeader
      darkModeEnabled: 'تم تفعيل الوضع الداكن',
      lightModeEnabled: 'تم تفعيل الوضع الفاتح',
      languageChanged: 'تم تغيير اللغة إلى {{lang}}',
      // PWA
      pwaInstallTitle: 'تثبيت التطبيق',
      pwaInstallMsg: 'أضفه إلى الشاشة الرئيسية للوصول السريع',
      pwaInstall: 'تثبيت',
      pwaDismiss: 'لا تظهر مرة أخرى',
      pwaHowToTitle: 'التثبيت على جهازك',
      pwaHowToSubtitle: 'اتبع الخطوات حسب نظام التشغيل',
      pwaIos: 'iOS',
      pwaAndroid: 'Android',
      pwaIosStep1: 'افتح هذه الصفحة في Safari',
      pwaIosStep2: 'اضغط على زر المشاركة في أسفل الشاشة',
      pwaIosStep3: 'مرّر للأسفل واضغط على إضافة إلى الشاشة الرئيسية',
      pwaIosStep4: 'اضغط على إضافة في الزاوية العلوية اليمنى',
      pwaAndroidStep1: 'افتح هذه الصفحة في Chrome',
      pwaAndroidStep2: 'اضغط على قائمة النقاط الثلاث في أعلى اليمين',
      pwaAndroidStep3: 'اضغط على تثبيت التطبيق أو إضافة إلى الشاشة الرئيسية',
      pwaAndroidStep4: 'اضغط على تثبيت للتأكيد',
      pwaGotIt: 'حسناً',
      allNewsLoaded: 'تم تحميل جميع الأخبار',
      loadMore: 'تحميل المزيد',
      amountUSD: 'المبلغ (دولار أمريكي)',
      avatarUpdated: 'تم تحديث صورة الملف الشخصي',
      disable2FATitle: 'تعطيل المصادقة الثنائية',
      disable2FAWarningTitle: 'سيكون حسابك أقل أماناً',
      disable2FAWarningDesc:
        'يؤدي تعطيل المصادقة الثنائية إلى تقليل حماية حسابك. قد يتمكن أي شخص يملك كلمة مرورك من تسجيل الدخول.',
      kycIdentityFront: 'وثيقة الهوية — الوجه الأمامي',
      kycIdentityBack: 'وثيقة الهوية — الوجه الخلفي',
      kycProofAddress: 'إثبات العنوان',
      kycDocApprovedTitle: 'تمت الموافقة',
      kycDocApprovedDesc: 'تم التحقق من هذا المستند والموافقة عليه.',
      minChars: '8 أحرف على الأقل',
      mustIncludeUpperNum: 'يجب أن يتضمن حرفاً كبيراً ورقماً',
      passwordChanged: 'تم تغيير كلمة المرور بنجاح',
      passwordChangeFailed: 'فشل تغيير كلمة المرور',
      passwordsNoMatch: 'كلمتا المرور غير متطابقتين',
      profileUpdated: 'تم تحديث الملف الشخصي',
      profileUpdateFailed: 'فشل تحديث الملف الشخصي',
      required: 'مطلوب',
      searchCountry: 'ابحث عن الدولة',
      setupStepsTitle: 'خطوات الإعداد',
      setup2FAStep1: 'ثبّت Google Authenticator أو Authy على هاتفك',
      setup2FAStep2: 'امسح رمز QR أو أدخل المفتاح السري',
      setup2FAStep3: 'أدخل الرمز المكون من 6 أرقام لتفعيل المصادقة الثنائية',
      removeStepsTitle: 'كيفية التعطيل',
      remove2FAStep1: 'افتح تطبيق المصادقة',
      remove2FAStep2: 'أدخل الرمز الحالي المكون من 6 أرقام',
      remove2FAStep3: 'أكد لتعطيل المصادقة الثنائية',
      twoFADisableFailed: 'فشل تعطيل المصادقة الثنائية',
      uploadedSuccess: 'تم رفع {{label}} بنجاح',
      termsContent:
        'باستخدام هذا التطبيق فإنك توافق على شروط الخدمة هذه. يجب أن تكون في السن القانوني في نطاق اختصاصك وأن تحافظ على سرية بيانات حسابك. ينطوي التداول على مخاطر خسارة كبيرة وقد لا يكون مناسباً لجميع المستثمرين. قد نعلق أو ننهي الوصول في حال الاشتباه بالاحتيال أو إساءة استخدام السوق أو انتهاك هذه الشروط. للاستفسارات تواصل مع الدعم.',
      privacyContent:
        'نجمع ونعالج البيانات الشخصية اللازمة لتشغيل حسابك وإتمام التحقق وتقديم خدمات التداول. قد يشمل ذلك بيانات الهوية ومعلومات الاتصال وسجل المعاملات. تُحفظ البيانات بشكل آمن ولا تُشارك إلا عند الاقتضاء قانوناً أو لتقديم الخدمة. يمكنك طلب الوصول إلى بياناتك أو تصحيحها أو حذفها عبر التواصل مع الدعم.',
    },
  },
  he: {
    translation: {
      login: 'התחברות',
      email: 'דואר אלקטרוני',
      password: 'סיסמה',
      forgotPassword: 'שכחת סיסמה?',
      rememberMe: 'זכור אותי',
      twoFA: 'אימות דו-שלבי',
      twoFACode: 'קוד בן 6 ספרות',
      liveAccount: 'חשבון אמיתי',
      demoAccount: 'חשבון דמו',
      balance: 'יתרה',
      equity: 'הון עצמי',
      deposit: 'הפקדה',
      withdraw: 'משיכה',
      noData: 'לא נמצאו נתונים',
      loading: 'טוען...',
      dashboard: 'לוח בקרה',
      trade: 'מסחר',
      transactions: 'עסקאות',
      accounts: 'חשבונות',
      settings: 'הגדרות',
      margin: 'מרווח בשימוש',
      freeMargin: 'מרווח חופשי',
      marginLevel: 'רמת מרווח',
      openPL: 'רווח/הפסד פתוח',
      history: 'היסטוריה',
      amount: 'סכום',
      paymentMethod: 'אמצעי תשלום',
      bankTransfer: 'העברה בנקאית',
      creditCard: 'כרטיס אשראי / חיוב',
      crypto: 'מטבע קריפטו',
      submit: 'שלח',
      cancel: 'ביטול',
      confirm: 'אישור',
      logout: 'התנתקות',
      profile: 'פרופיל',
      kycStatus: 'סטטוס KYC',
      verified: 'מאומת',
      pending: 'בבדיקה',
      rejected: 'נדחה',
      notSubmitted: 'לא הוגש',
      changePassword: 'שינוי סיסמה',
      currentPassword: 'סיסמה נוכחית',
      newPassword: 'סיסמה חדשה',
      confirmPassword: 'אישור סיסמה',
      language: 'שפה',
      theme: 'ערכת נושא',
      dark: 'כהה',
      light: 'בהיר',
      notifications: 'התראות',
      tickets: 'תמיכה',
      createTicket: 'כרטיס חדש',
      subject: 'נושא',
      message: 'הודעה',
      send: 'שלח',
      name: 'שם מלא',
      phone: 'מספר טלפון',
      country: 'מדינה',
      saveChanges: 'שמור שינויים',
      switchAccount: 'החלף חשבון',
      activeAccount: 'חשבון פעיל',
      invalidCredentials: 'פרטים שגויים — השתמש בחשבונות הדמו להתחברות',
      welcomeBack: 'ברוך שובך',
      marketNews: 'חדשות שוק',
      recentTransactions: 'עסקאות אחרונות',
      status: 'סטטוס',
      date: 'תאריך',
      type: 'סוג',
      completed: 'הושלם',
      processingStatus: 'בעיבוד',
      pendingStatus: 'ממתין',
      failedStatus: 'נכשל',
      server: 'שרת',
      leverage: 'מינוף',
      currency: 'מטבע',
      accountType: 'סוג חשבון',
      support: 'תמיכה',
      analysis: 'ניתוחים',
      newTicket: 'כרטיס חדש',
      newAccount: 'חשבון חדש',
      myAccounts: 'החשבונות שלי',
      accountOverview: 'סקירת חשבון',
      quickActions: 'פעולות מהירות',
      funds: 'כספים',
      security: 'אבטחה',
      verification: 'אימות',
      twoFactorAuth: 'אימות דו-שלבי',
      enable: 'הפעל',
      disable: 'השבת',
      uploadDocument: 'העלה מסמך',
      changeAvatar: 'שנה תמונה',
      removeAvatar: 'הסר תמונה',
      open: 'פתוח',
      inProgress: 'בטיפול',
      resolved: 'נפתר',
      closed: 'סגור',
      low: 'נמוך',
      medium: 'בינוני',
      high: 'גבוה',
      priority: 'עדיפות',
      category: 'קטגוריה',
      submitTicket: 'שלח כרטיס',
      typeMessage: 'הקלד הודעה...',
      noTickets: 'אין כרטיסים עדיין',
      describeIssue: 'תאר את הבעיה שלך',
      marketInsights: 'תובנות שוק ומחקר',
      bullish: 'שורי',
      bearish: 'דובי',
      neutral: 'ניטרלי',
      readTime: 'קריאה',
      allLoaded: 'כל הניתוחים נטענו',
      loadingAnalyses: 'טוען ניתוחים...',
      goodMorning: 'בוקר טוב',
      goodAfternoon: 'צהריים טובים',
      goodEvening: 'ערב טוב',
      bank: 'בנק',
      selectPaymentMethod: 'בחר אמצעי תשלום',
      walletAddress: 'כתובת ארנק',
      networkWarning: 'שלח רק לרשת זו',
      copyAddress: 'העתק כתובת',
      scanQR: 'סרוק קוד QR',
      demoCredentials: 'פרטי חשבון דמו',
      signIn: 'התחבר',
      verifyCode: 'אמת קוד',
      enterCode: 'הזן את הקוד בן 6 הספרות מאפליקציית האימות',
      backToLogin: 'חזור להתחברות',
      active: 'פעיל',
      switch: 'החלף',
      // Register
      createAccount: 'צור חשבון',
      fillDetails: 'מלא את הפרטים למטה כדי להתחיל.',
      fullNamePlaceholder: 'ישראל ישראלי',
      emailPlaceholder: 'your@email.com',
      phonePlaceholder: '+972 (555) 000-0000',
      minCharsPlaceholder: 'מינ. 8 תווים',
      repeatPasswordPlaceholder: 'חזור על הסיסמה',
      passwordWeak: 'חלשה',
      passwordMedium: 'בינונית',
      passwordStrong: 'חזקה',
      creatingAccount: 'יוצר חשבון...',
      alreadyHaveAccount: 'כבר יש לך חשבון?',
      dontHaveAccount: 'אין לך חשבון?',
      register: 'הרשמה',
      back: 'חזור',
      // Forgot Password
      forgotPasswordTitle: 'שכחת סיסמה?',
      forgotPasswordDesc: 'הזן את כתובת הדואר האלקטרוני שלך ונשלח לך קישור לאיפוס הסיסמה.',
      checkInbox: 'בדוק את תיבת הדואר הנכנס',
      resetLinkSent: 'שלחנו קישור איפוס אל',
      sendResetLink: 'שלח קישור איפוס',
      sending: 'שולח...',
      // Reset Password
      setNewPassword: 'הגדר סיסמה חדשה',
      setNewPasswordDesc: 'הזן את קוד האימות מהדואר האלקטרוני ובחר סיסמה חדשה.',
      verificationCode: 'קוד אימות',
      enterCodeFromEmail: 'הזן קוד מהדואר האלקטרוני',
      passwordUpdated: 'הסיסמה עודכנה!',
      canNowSignIn: 'כעת תוכל להתחבר עם הסיסמה החדשה שלך.',
      goToLogin: 'עבור להתחברות',
      updating: 'מעדכן...',
      updatePassword: 'עדכן סיסמה',
      // Login screen
      signInToAccount: 'התחבר לחשבון המסחר שלך',
      emailOrAccountId: 'דואר אלקטרוני או מזהה חשבון',
      enterYourPassword: 'הזן את הסיסמה שלך',
      signingIn: 'מתחבר...',
      backToLoginLink: 'חזור להתחברות',
      twoFactorAuthTitle: 'אימות דו-שלבי',
      enterSixDigitCode: 'הזן את הקוד בן 6 הספרות מאפליקציית האימות להמשך.',
      authenticatorCode: 'קוד אימות',
      codeRequired: 'קוד נדרש',
      verifying: 'מאמת...',
      openAuthApp: 'פתח את אפליקציית האימות והזן את הקוד הנוכחי בן 6 הספרות.',
      // Transactions
      tradingAccount: 'חשבון מסחר',
      selectTradingAccount: 'בחר חשבון מסחר',
      availableBalance: 'יתרה זמינה',
      selectDepositMethod: 'בחר שיטת הפקדה',
      selectWithdrawalMethod: 'בחר שיטת משיכה',
      selectBankAccount: 'בחר חשבון בנק',
      selectCryptocurrency: 'בחר מטבע קריפטו',
      bankDetails: 'פרטי בנק',
      bankName: 'שם הבנק',
      accountHolderName: 'שם בעל החשבון',
      accountNumber: 'מספר חשבון',
      swiftBic: 'SWIFT/BIC',
      amountLabel: 'סכום',
      submitDeposit: 'שלח הפקדה',
      submitWithdrawal: 'שלח משיכה',
      noTransactions: 'אין עסקאות עדיין',
      creditIn: 'כניסת אשראי',
      creditOut: 'יציאת אשראי',
      typeDeposit: 'הפקדה',
      typeWithdraw: 'משיכה',
      sendToAddress: 'שלח לכתובת',
      withdrawalAddress: 'כתובת משיכה',
      wrongAssetWarning: 'שליחת נכסים שגויים תגרום לאובדן קבוע.',
      wireSwiftSepa: 'העברה / SWIFT / SEPA',
      btcEthUsdt: 'BTC, ETH, USDT ועוד',
      // Settings
      twoFAEnabled: 'מופעל — Google Authenticator',
      twoFADisabled: 'מושבת — מומלץ להפעיל',
      activeSessions: 'סשנים פעילים',
      pushNotifications: 'התראות דחיפה',
      tradeAlertsDesc: 'התראות מסחר, הפקדות, חדשות',
      appVersion: 'גרסת האפליקציה',
      termsOfService: 'תנאי שירות',
      privacyPolicy: 'מדיניות פרטיות',
      contactSupport: 'צור קשר עם תמיכה',
      logOut: 'התנתק',
      headerSettings: 'הגדרות',
      headerLogout: 'התנתקות',
      logOutConfirmTitle: 'התנתקות',
      logOutConfirmMsg:
        'האם אתה בטוח שברצונך להתנתק מ-application? הפוזיציות הפתוחות שלך לא יושפעו.',
      stay: 'הישאר',
      updatePasswordBtn: 'עדכן סיסמה',
      saveChangesBtn: 'שמור שינויים',
      kycStatusLabel: 'סטטוס KYC',
      dropFileHere: 'גרור קובץ לכאן או לחץ להעלאה',
      fileFormats: 'JPG, PNG, PDF — מקסימום 10MB',
      uploading: 'מעלה...',
      uploaded: 'הועלה',
      docsReviewTime: 'המסמכים נבדקים תוך 1–3 ימי עסקים.',
      step1InstallAuth: 'שלב 1: התקן אפליקציית אימות',
      downloadAuthApp: 'הורד אפליקציית אימות',
      step1Desc:
        'התקן Google Authenticator או Authy במכשיר הנייד שלך. אפליקציות אלה מייצרות סיסמאות חד-פעמיות מבוססות זמן (TOTP) לאבטחת חשבונך.',
      iHaveApp: 'יש לי את האפליקציה — המשך',
      step2ScanQR: 'שלב 2: סרוק קוד QR',
      scanWithApp: 'סרוק עם אפליקציית האימות שלך',
      enterManually: 'או הזן את המפתח הסודי ידנית:',
      enter6DigitVerify: 'הזן קוד בן 6 ספרות לאימות',
      verifyEnable: 'אמת והפעל',
      twoFADisabledMsg: 'אימות דו-שלבי הושבת — החשבון שלך פחות מאובטח.',
      twoFAEnabledTitle: 'אימות דו-שלבי הופעל!',
      twoFAEnabledDesc: 'אימות דו-שלבי פעיל כעת. שמור את קודי הגיבוי במקום בטוח.',
      doneSaveBackup: 'סיום — שמור קודי גיבוי',
      currentSession: 'נוכחי',
      revoke: 'בטל',
      preferences: 'העדפות',
      // Sub Accounts
      newAccountBtn: 'חשבון חדש',
      createNewAccount: 'צור חשבון חדש',
      accountTypeLabel: 'סוג חשבון',
      summary: 'סיכום',
      demoDesc: 'תרגל עם כספים וירטואליים',
      realDesc: 'סחר עם כסף אמיתי',
      creating: 'יוצר...',
      createAccountBtn: 'צור חשבון',
      noTradingAccounts: 'אין חשבונות מסחר',
      createToGetStarted: 'צור חשבון חדש כדי להתחיל',
      switchAccountTitle: 'החלף חשבון',
      switchAccountMsg: 'לעבור לחשבון #{{id}}? הסשן הפעיל שלך יתעדכן.',
      // Support
      ticketCount: '{{count}} כרטיס',
      ticketCountPlural: '{{count}} כרטיסים',
      briefDescription: 'תיאור קצר של הבעיה שלך',
      selectCategory: 'בחר קטגוריה',
      describeInDetail: 'תאר את הבעיה שלך בפירוט...',
      ticketCreated: 'כרטיס {{id}} נוצר בהצלחה',
      ticketClosed: 'כרטיס זה {{status}}. פתח כרטיס חדש אם אתה זקוק לסיוע נוסף.',
      updatedAt: 'עודכן {{time}}',
      // Analysis
      analysisTitle: 'ניתוחים',
      analysisDirection: 'כיוון',
      analysisBuy: 'קנייה',
      analysisSell: 'מכירה',
      analysisBuySell: 'קנייה / מכירה',
      analysisDescription: 'תיאור',
      analysisTags: 'תגיות',
      analysisEntry: 'כניסה',
      analysisSL: 'סטופ לוס',
      analysisTP1: 'TP 1',
      analysisTP2: 'TP 2',
      analysisTP3: 'TP 3',
      // Dashboard
      goodEvening2: 'ערב טוב 👋',
      // Notifications
      notificationsTitle: 'התראות',
      markAllRead: 'סמן הכל כנקרא',
      noNotifications: 'אין התראות',
      read: 'נקרא',
      unread: 'לא נקרא',
      // Bottom Nav
      navDashboard: 'לוח בקרה',
      navTrade: 'מסחר',
      navFunds: 'כספים',
      navAccounts: 'חשבונות',
      navAnalysis: 'ניתוחים',
      navSettings: 'הגדרות',
      // Metric Cards
      atRisk: 'בסיכון',
      // TopHeader
      darkModeEnabled: 'מצב כהה הופעל',
      lightModeEnabled: 'מצב בהיר הופעל',
      languageChanged: 'השפה שונתה ל-{{lang}}',
      // PWA
      pwaInstallTitle: 'התקן אפליקציה',
      pwaInstallMsg: 'הוסף אותו למסך הבית לגישה מהירה',
      pwaInstall: 'התקן',
      pwaDismiss: 'לא להציג שוב',
      pwaHowToTitle: 'התקן במכשיר שלך',
      pwaHowToSubtitle: 'פעל לפי השלבים של הפלטפורמה שלך',
      pwaIos: 'iOS',
      pwaAndroid: 'Android',
      pwaIosStep1: 'פתח דף זה ב-Safari',
      pwaIosStep2: 'הקש על כפתור השיתוף בתחתית המסך',
      pwaIosStep3: 'גלול למטה והקש על הוסף למסך הבית',
      pwaIosStep4: 'הקש על הוסף בפינה הימנית העליונה',
      pwaAndroidStep1: 'פתח דף זה ב-Chrome',
      pwaAndroidStep2: 'הקש על תפריט שלוש הנקודות בפינה הימנית העליונה',
      pwaAndroidStep3: 'הקש על התקן אפליקציה או הוסף למסך הבית',
      pwaAndroidStep4: 'הקש על התקן לאישור',
      pwaGotIt: 'הבנתי',
      allNewsLoaded: 'כל החדשות נטענו',
      loadMore: 'טען עוד',
      amountUSD: 'סכום (USD)',
      avatarUpdated: 'תמונת הפרופיל עודכנה',
      disable2FATitle: 'השבת אימות דו-שלבי',
      disable2FAWarningTitle: 'החשבון שלך יהיה פחות מאובטח',
      disable2FAWarningDesc:
        'השבתת אימות דו-שלבי מפחיתה את ההגנה על החשבון. כל מי שיש לו את הסיסמה שלך עשוי להתחבר.',
      kycIdentityFront: 'מסמך זהות — צד קדמי',
      kycIdentityBack: 'מסמך זהות — צד אחורי',
      kycProofAddress: 'אישור כתובת',
      kycDocApprovedTitle: 'אושר',
      kycDocApprovedDesc: 'מסמך זה אומת ואושר.',
      minChars: 'לפחות 8 תווים',
      mustIncludeUpperNum: 'חייב לכלול אות גדולה ומספר',
      passwordChanged: 'הסיסמה שונתה בהצלחה',
      passwordChangeFailed: 'שינוי הסיסמה נכשל',
      passwordsNoMatch: 'הסיסמאות אינן תואמות',
      profileUpdated: 'הפרופיל עודכן',
      profileUpdateFailed: 'עדכון הפרופיל נכשל',
      required: 'שדה חובה',
      searchCountry: 'חפש מדינה',
      setupStepsTitle: 'שלבי הגדרה',
      setup2FAStep1: 'התקן Google Authenticator או Authy בטלפון',
      setup2FAStep2: 'סרוק את קוד ה-QR או הזן את המפתח הסודי',
      setup2FAStep3: 'הזן את הקוד בן 6 הספרות כדי להפעיל אימות דו-שלבי',
      removeStepsTitle: 'איך להשבית',
      remove2FAStep1: 'פתח את אפליקציית האימות',
      remove2FAStep2: 'הזן את הקוד הנוכחי בן 6 הספרות',
      remove2FAStep3: 'אשר כדי להשבית את האימות הדו-שלבי',
      twoFADisableFailed: 'השבתת האימות הדו-שלבי נכשלה',
      uploadedSuccess: '{{label}} הועלה בהצלחה',
      termsContent:
        'בשימוש ביישום זה אתה מסכים לתנאי השירות. עליך להיות בגיל החוקי בתחום השיפוט שלך ואתה אחראי לשמירה על סודיות פרטי החשבון. מסחר כרוך בסיכון מהותי להפסד ואינו מתאים לכל משקיע. אנו עשויים להשעות או לסיים גישה במקרה של חשד להונאה, ניצול שוק או הפרת תנאים אלה. לשאלות פנה לתמיכה.',
      privacyContent:
        'אנו אוספים ומעבדים נתונים אישיים הנדרשים להפעלת החשבון, השלמת אימות ומתן שירותי מסחר. זה עשוי לכלול פרטי זהות, פרטי קשר והיסטוריית עסקאות. הנתונים נשמרים באופן מאובטח ומשותפים רק כאשר החוק מחייב או לצורך מתן השירות. ניתן לבקש גישה, תיקון או מחיקה של הנתונים באמצעות פנייה לתמיכה.',
    },
  },
};

if (!i18n?.isInitialized) {
  i18n?.use(initReactI18next)?.init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });
}

export default i18n;